/* eslint-disable ember/no-jquery */
import $ from "jquery";
import { registerAdminDashboardReportRenderer } from "discourse/admin/lib/admin-dashboard-report-renderers";
import { registerAdminDashboardSection } from "discourse/admin/lib/admin-dashboard-sections";
import { registerAdminReportRelatedItemsRenderer } from "discourse/admin/lib/admin-report-related-items";
import { _renderBlocks } from "discourse/blocks/block-outlet";
import { addAboutPageActivity } from "discourse/components/about-page";
import { addBulkDropdownButton } from "discourse/components/bulk-select-topics-dropdown";
import { addCardClickListenerSelector } from "discourse/components/card-contents-base";
import {
  addApiImageWrapperButtonClickEvent,
  addComposerUploadHandler,
  addComposerUploadMarkdownResolver,
  addComposerUploadPreProcessor,
} from "discourse/components/composer-editor";
import { addPluginDocumentTitleCounter } from "discourse/components/d-document";
import { forceDropdownForMenuPanels as glimmerForceDropdownForMenuPanels } from "discourse/components/glimmer-site-header";
import { addGlobalNotice } from "discourse/components/global-notice";
import { headerButtonsDAG } from "discourse/components/header";
import { headerIconsDAG } from "discourse/components/header/icons";
import { registeredTabs } from "discourse/components/more-topics";
import { addPluginOutletDecorator } from "discourse/components/plugin-connector";
import { STREAM_HTML_DECORATOR } from "discourse/components/post/cooked-html";
import { addGroupPostSmallActionCode } from "discourse/components/post/small-action";
import {
  addPluginReviewableParam,
  registerReviewableActionModal,
} from "discourse/components/reviewable/item";
import { addAdvancedSearchOptions } from "discourse/components/search-advanced-options";
import { addSearchSuggestion } from "discourse/components/search-menu/results/assistant";
import { addItemSelectCallback as addSearchMenuAssistantSelectCallback } from "discourse/components/search-menu/results/assistant-item";
import {
  addQuickSearchRandomTip,
  removeDefaultQuickSearchRandomTips,
} from "discourse/components/search-menu/results/random-quick-tip";
import { addOnKeyUpCallback } from "discourse/components/search-menu/search-term";
import { REFRESH_COUNTS_APP_EVENT_NAME as REFRESH_USER_SIDEBAR_CATEGORIES_SECTION_COUNTS_APP_EVENT_NAME } from "discourse/components/sidebar/user/categories-section";
import { addTopicParticipantClassesCallback } from "discourse/components/topic-map/topic-participant";
import { setDesktopScrollAreaHeight } from "discourse/components/topic-timeline/container";
import { setNotificationsLimit as setUserMenuNotificationsLimit } from "discourse/components/user-menu/notifications-list";
import { addUserMenuProfileTabItem } from "discourse/components/user-menu/profile-tab-content";
import { addDiscoveryQueryParam } from "discourse/controllers/discovery/list";
import { registerFullPageSearchType } from "discourse/controllers/full-page-search";
import { registerCustomPostMessageCallback as registerCustomPostMessageCallback1 } from "discourse/controllers/topic";
import { addBeforeLoadMoreCallback as addBeforeLoadMoreNotificationsCallback } from "discourse/controllers/user-notifications";
import { registerCustomUserNavMessagesDropdownRow } from "discourse/controllers/user-private-messages";
import { addUsernameSelectorDecorator } from "discourse/helpers/decorate-username-selector";
import { registerReviewableStatusName } from "discourse/helpers/reviewable-status";
import { addBeforeAuthCompleteCallback } from "discourse/instance-initializers/auth-complete";
import { registerAdminPluginConfigNav } from "discourse/lib/admin-plugin-config-nav";
import { registerPluginHeaderActionComponent } from "discourse/lib/admin-plugin-header-actions";
import { registerReportModeComponent } from "discourse/lib/admin-report-additional-modes";
import { captureCallSite } from "discourse/lib/blocks/-internals/error";
import {
  _registerBlock,
  _registerBlockFactory,
} from "discourse/lib/blocks/-internals/registry/block";
import { _registerConditionType } from "discourse/lib/blocks/-internals/registry/condition";
import { _registerOutlet } from "discourse/lib/blocks/-internals/registry/outlet";
import classPrepend, {
  withPrependsRolledBack,
} from "discourse/lib/class-prepend";
import { registerComposerAction } from "discourse/lib/composer/actions-registry";
import { addPopupMenuOption } from "discourse/lib/composer/custom-popup-menu-options";
import { registerRichEditorExtension } from "discourse/lib/composer/rich-editor-extensions";
import {
  _INTERNAL_SOURCE_KEY,
  CORE_SOURCE,
} from "discourse/lib/customization-source";
import {
  deferClassModification,
  lazyClassFor,
} from "discourse/lib/deferred-class-modifications";
import deprecated from "discourse/lib/deprecated";
import { registerDesktopNotificationHandler } from "discourse/lib/desktop-notifications";
import { downloadCalendar } from "discourse/lib/download-calendar";
import { registeredEditCategoryTabs } from "discourse/lib/edit-category-tabs";
import { isDevelopment, isTesting } from "discourse/lib/environment";
import { getOwnerWithFallback } from "discourse/lib/get-owner";
import { registerHashtagType } from "discourse/lib/hashtag-type-registry";
import { makeArray } from "discourse/lib/helpers";
import {
  registerHighlightJSLanguage,
  registerHighlightJSPlugin,
} from "discourse/lib/highlight-syntax";
import { registerIconRenderer, replaceIcon } from "discourse/lib/icon-library";
import {
  defineModelAccessor,
  defineModelMethod,
  defineModelResettableField,
  registerModelCallback,
  registerModelField,
  registerModelSaveProperty,
  stampModelClass,
} from "discourse/lib/model-extensions";
import { registerModelTransformer } from "discourse/lib/model-transformers";
import { registerNotificationTypeRenderer } from "discourse/lib/notification-types-manager";
import { registerOnBeforeCategoryTypesChange } from "discourse/lib/on-before-category-types-change";
import { addGTMPageChangedCallback } from "discourse/lib/page-tracker";
import {
  extraConnectorClass,
  extraConnectorComponent,
} from "discourse/lib/plugin-connectors";
import { registerTopicFooterButton } from "discourse/lib/register-topic-footer-button";
import { registerTopicFooterDropdown } from "discourse/lib/register-topic-footer-dropdown";
import { replaceTagRenderer } from "discourse/lib/render-tag";
import { addTagsHtmlCallback } from "discourse/lib/render-tags";
import { addFeaturedLinkMetaDecorator } from "discourse/lib/render-topic-featured-link";
import { reportClientError } from "discourse/lib/report-client-error";
import {
  addLogSearchLinkClickedCallbacks,
  addSearchResultsCallback,
} from "discourse/lib/search";
import Sharing from "discourse/lib/sharing";
import { addAdminSidebarSectionLink } from "discourse/lib/sidebar/admin-sidebar";
import { addSectionLink as addCustomCommunitySectionLink } from "discourse/lib/sidebar/custom-community-section-links";
import {
  addSidebarPanel,
  addSidebarSection,
} from "discourse/lib/sidebar/custom-sections";
import {
  registerCustomCategoryLockIcon,
  registerCustomCategorySectionLinkPrefix,
  registerCustomCountable as registerUserCategorySectionLinkCountable,
} from "discourse/lib/sidebar/user/categories-section/category-section-link";
import { registerCustomTagSectionLinkPrefixIcon } from "discourse/lib/sidebar/user/tags-section/base-tag-section-link";
import { addUserNavSidebarLink } from "discourse/lib/sidebar/user-nav-sidebar";
import { consolePrefix } from "discourse/lib/source-identifier";
import {
  _addTransformerName,
  _registerTransformer,
  transformerTypes,
} from "discourse/lib/transformer";
import { addCustomUserFieldValidationCallback } from "discourse/lib/user-fields-validation-helper";
import { registerUserMenuTab } from "discourse/lib/user-menu/tab";
import { replaceFormatter } from "discourse/lib/utilities";
import { _addCategoryPropertyForSave } from "discourse/models/category";
import Composer, {
  registerCustomizationCallback,
} from "discourse/models/composer";
import { addNavItem } from "discourse/models/nav-item";
import { _addTrackedPostProperty } from "discourse/models/post";
import {
  _addTrackedTopicProperty,
  registerCustomLastUnreadUrlCallback,
} from "discourse/models/topic";
import {
  addSaveableUserField,
  addSaveableUserOptionField,
} from "discourse/models/user";
import { preventCloaking } from "discourse/modifiers/post-stream-viewport-tracker";
import { setNotificationsLimit } from "discourse/routes/user-notifications";
import { CUSTOM_USER_SEARCH_OPTIONS } from "discourse/select-kit/components/user-chooser";
import { modifySelectKit } from "discourse/select-kit/lib/plugin-api";
import { addComposerSaveErrorCallback } from "discourse/services/composer";
import { disableDefaultKeyboardShortcuts } from "discourse/services/keyboard-shortcuts";
import {
  NON_STREAM_HTML_DECORATOR,
  registerHtmlDecorator,
} from "discourse/ui-kit/d-decorated-html";
import { addToolbarCallback } from "discourse/ui-kit/d-editor";
import {
  addExtraIconRenderer,
  replaceCategoryLinkRenderer,
} from "discourse/ui-kit/helpers/d-category-link";
import { registerCustomAvatarHelper } from "discourse/ui-kit/helpers/d-user-avatar";
import { addImageWrapperButton } from "discourse-markdown-it/features/image-controls";

const blockedModifications = ["component:topic-list"];

const appliedModificationIds = new WeakMap();

// This helper prevents us from applying the same `modifyClass` over and over in test mode.
function canModify(klass, type, resolverName, changes) {
  if (typeof changes === "function") {
    return true;
  }

  if (!changes.pluginId) {
    // eslint-disable-next-line no-console
    console.warn(
      consolePrefix(),
      "To prevent errors in tests, add a `pluginId` key to your `modifyClass` call. This will ensure the modification is only applied once."
    );
    return true;
  }

  let key = "_" + type + "/" + changes.pluginId + "/" + resolverName;

  if (appliedModificationIds.get(klass.class)?.includes(key)) {
    return false;
  } else {
    const modificationIds = appliedModificationIds.get(klass.class) || [];
    modificationIds.push(key);
    appliedModificationIds.set(klass.class, modificationIds);
    return true;
  }
}

function wrapWithErrorHandler(func, messageKey) {
  return function () {
    try {
      return func.call(this, ...arguments);
    } catch (error) {
      reportClientError(error, messageKey);
      if (isTesting()) {
        throw error;
      }
      return;
    }
  };
}

/**
 * @typedef {_PluginApi} PluginApi
 */
class _PluginApi {
  #source;

  constructor(container, source = CORE_SOURCE) {
    this.container = container;
    this.#source = source;
  }

  /** The plugin, theme, or core code this api was handed to. */
  get source() {
    return this.#source;
  }

  /**
   * Allows for manipulation of the header icons. This includes, adding, removing, or modifying the order of icons.
   *
   * Only the passing of components is supported, and by default the icons are added to the left of existing icons.
   *
   * Example: Add the chat icon to the header icons after the search icon
   * ```
   * api.headerIcons.add(
   *  "chat",
   *  ChatIconComponent,
   *  { after: "search" }
   * )
   * ```
   *
   * Example: Remove the chat icon from the header icons
   * ```
   * api.headerIcons.delete("chat")
   * ```
   *
   * Example: Reposition the chat icon to be before the user-menu icon and after the hamburger icon
   * ```
   * api.headerIcons.reposition("chat", { before: "user-menu", after: "hamburger" })
   * ```
   *
   * Example: Check if the chat icon is present in the header icons (returns true of false)
   * ```
   * api.headerIcons.has("chat")
   * ```
   *
   * If you are looking to add a button with a dropdown, you can implement a `DMenu` which has a `content` block
   * you want create a button in the header that opens a dropdown panel with additional content.
   *
   * ```
   * const IconWithDropdown = <template>
    *
    <DMenu @icon="foo" title={{i18n "title"}}>
      *
      <:content as |args|>
        *       dropdown content here
        *
        <DButton @action={{args.close}} @icon="bar" />
        *     </:content>
      *   </DMenu>
    * </template>;
   *
   * api.headerIcons.add("icon-name", IconWithDropdown, { before: "search" })
   * ```
   *
   **/
  get headerIcons() {
    return headerIconsDAG();
  }

  /**
   * Allows for manipulation of the header buttons. This includes, adding, removing, or modifying the order of buttons.
   *
   * Only the passing of components is supported, and by default the buttons are added to the left of existing buttons.
   *
   * Example: Add a `foo` button to the header buttons after the auth buttons
   * ```
   * api.headerButtons.add(
   *  "foo",
   *  FooComponent,
   *  { after: "auth" }
   * )
   * ```
   *
   * Example: Remove the `foo` button from the header buttons
   * ```
   * api.headerButtons.delete("foo")
   * ```
   *
   * Example: Reposition the `foo` button to be before the `bar` and after the `baz` button
   * ```
   * api.headerButtons.reposition("foo", { before: "bar", after: "baz" })
   * ```
   *
   * Example: Check if the `foo` button is present in the header buttons (returns true of false)
   * ```
   * api.headerButtons.has("foo")
   * ```
   *
   **/
  get headerButtons() {
    return headerButtonsDAG();
  }

  /**
   * Use this function to retrieve the currently logged in user within your plugin.
   * If the user is not logged in, it will be `null`.
   **/
  getCurrentUser() {
    return this._lookupContainer("service:current-user");
  }

  /**
   * Allows you to overwrite or extend methods in a class.
   *
   * You should add a `pluginId` property to identify your plugin
   * to help Discourse reload classes properly.
   *
   * For example:
   *
   * ```
   * api.modifyClass('controller:composer', {
   *   pluginId: 'my-plugin',
   *   actions: {
   *     newActionHere() { }
   *   }
   * });
   * ```
   *
   * Deprecated for `model:` types — use the `addModel*` APIs instead.
   **/
  modifyClass(resolverName, changes, opts) {
    this.#deprecateModifyClass(resolverName, "modifyClass");

    const klass = this._resolveClass(resolverName);
    if (!klass) {
      this.#deferModification(resolverName, () =>
        this.modifyClass(resolverName, changes, opts)
      );
      return;
    }

    if (canModify(klass, "member", resolverName, changes)) {
      delete changes.pluginId;

      if (typeof changes === "function") {
        classPrepend(klass.class, changes);
      } else if (klass.class.reopen) {
        withPrependsRolledBack(klass.class, () => {
          klass.class.reopen(changes);
        });
      } else {
        Object.defineProperties(
          klass.class.prototype || klass.class,
          Object.getOwnPropertyDescriptors(changes)
        );
      }
    }

    return klass;
  }

  /**
   * Allows you to overwrite or extend static methods in a class.
   *
   * For example:
   *
   * ```
   * api.modifyClassStatic('controller:composer', {
   *   superFinder() { return []; }
   * });
   * ```
   *
   * Deprecated for `model:` types — use the `addModel*` APIs instead.
   **/
  modifyClassStatic(resolverName, changes, opts) {
    this.#deprecateModifyClass(resolverName, "modifyClassStatic");

    const klass = this._resolveClass(resolverName);
    if (!klass) {
      this.#deferModification(resolverName, () =>
        this.modifyClassStatic(resolverName, changes, opts)
      );
      return;
    }

    if (canModify(klass, "static", resolverName, changes)) {
      delete changes.pluginId;
      withPrependsRolledBack(klass.class, () => {
        klass.class.reopenClass(changes);
      });
    }

    return klass;
  }

  /**
   * Add a new valid behavior transformer name.
   *
   * Use this API to add a new behavior transformer name that can be used in the `registerValueTransformer` API.
   *
   * Notice that this API must be used in a pre-initializer, executed before `freeze-valid-transformers`, otherwise it will throw an error:
   *
   * Example:
   *
   * // pre-initializers/my-transformers.js
   *
   * export default {
   *   before: "freeze-valid-transformers",
   *
   *   initialize() {
   *     withPluginApi("1.33.0", (api) => {
   *       api.addBehaviorTransformerName("my-unique-transformer-name");
   *     }),
   *   },
   * };
   *
   * @param name the name of the new transformer
   *
   */
  addBehaviorTransformerName(name) {
    _addTransformerName(name, transformerTypes.BEHAVIOR);
  }

  /**
   * Register a transformer to override behavior defined in Discourse.
   *
   * Example: to perform an action before the expected behavior
   * ```
   * api.registerBehaviorTransformer("example-transformer", ({next, context}) => {
   *   exampleNewAction(); // action performed before the expected behavior
   *
   *   next(); //iterates over the transformer queue processing the behaviors
   * });
   * ```
   *
   * Example: to perform an action after the expected behavior
   * ```
   * api.registerBehaviorTransformer("example-transformer", ({next, context}) => {
   *   next(); //iterates over the transformer queue processing the behaviors
   *
   *   exampleNewAction(); // action performed after the expected behavior
   * });
   * ```
   *
   * Example: to use a value returned by the expected behavior to decide if an action must be performed
   * ```
   * api.registerBehaviorTransformer("example-transformer", ({next, context}) => {
   *   const expected = next(); //iterates over the transformer queue processing the behaviors
   *
   *   if (expected === "EXPECTED") {
   *     exampleNewAction(); // action performed after the expected behavior
   *   }
   * });
   * ```
   *
   * Example: to abort the expected behavior based on a condition
   * ```
   * api.registerBehaviorTransformer("example-transformer", ({next, context}) => {
   *   if (context.property) {
   *     // not calling next() on a behavior transformer aborts executing the expected behavior
   *
   *     return;
   *   }
   *
   *   next();
   * });
   * ```
   *
   * @param {string} transformerName the name of the transformer
   * @param {function({next, context})} behaviorCallback callback to be used to transform or override the behavior.
   * @param {*} behaviorCallback.next callback that executes the remaining transformer queue producing the expected
   * behavior. Notice that this includes the default behavior and if next() is not called in your transformer's callback
   * the default behavior will be completely overridden
   * @param {*} [behaviorCallback.context] the optional context in which the behavior is being transformed
   * @returns {boolean} True if the transformer exists, false otherwise.
   */
  registerBehaviorTransformer(transformerName, behaviorCallback) {
    return _registerTransformer(
      transformerName,
      transformerTypes.BEHAVIOR,
      behaviorCallback
    );
  }

  /**
   * Add a new valid value transformer name.
   *
   * Use this API to add a new value transformer name that can be used in the `registerValueTransformer` API.
   *
   * Notice that this API must be used in a pre-initializer, executed before `freeze-valid-transformers`, otherwise it will throw an error:
   *
   * Example:
   *
   * // pre-initializers/my-transformers.js
   *
   * export default {
   *   before: "freeze-valid-transformers",
   *
   *   initialize() {
   *     withPluginApi("1.33.0", (api) => {
   *       api.addValueTransformerName("my-unique-transformer-name");
   *     });
   *   },
   * };
   *
   * @param name the name of the new transformer
   *
   */
  addValueTransformerName(name) {
    _addTransformerName(name, transformerTypes.VALUE);
  }

  /**
   * Register a transformer to override values defined in Discourse.
   *
   * Example: return a static value
   * ```
   * api.registerValueTransformer("example-transformer", () => "value");
   * ```
   *
   * Example: transform the current value
   * ```
   * api.registerValueTransformer("example-transformer", ({value}) => value * 10);
   * ```
   *
   * Example: transform the current value based on a context property
   * ```
   * api.registerValueTransformer("example-transformer", ({value, context}) => {
   *   if (context.property) {
   *     return value * 10;
   *   }
   *
   *   return value;
   * });
   * ```
   *
   * @param {string} transformerName the name of the transformer
   * @param {function({value, context})} valueCallback callback to be used to transform the value. To avoid potential
   * errors or unexpected behavior the callback must be a pure function, i.e. return the transform value instead of
   * mutating the input value, return the same output for the same input and not have any side effects.
   * @param {*} valueCallback.value the value to be transformed
   * @param {*} [valueCallback.context] the optional context in which the value is being transformed
   * @returns {boolean} True if the transformer exists, false otherwise.
   */
  registerValueTransformer(transformerName, valueCallback) {
    return _registerTransformer(
      transformerName,
      transformerTypes.VALUE,
      valueCallback
    );
  }

  /**
   * If you want to use custom icons in your discourse application,
   * you can register a renderer that will return an icon in the
   * format required.
   *
   * For example, the following resolver will render a smile in the place
   * of every icon on Discourse.
   *
   * api.registerIconRenderer({
   *   name: 'smile-icons',
   *
   *   // for the place in code that render a string
   *   string() {
   *     return "<svg class=\"fa d-icon d-icon-far-face-smile svg-icon\" aria-hidden=\"true\"><use href=\"#far-face-smile\"></use></svg>";
   *   },
   *
   *   // for the places in code that render virtual dom elements
   *   element() {
   *     const svgElement = document.createElementNS(SVG_NAMESPACE, "svg");
   *     svgElement.setAttribute("class", "fa d-icon d-icon-far-face-smile");
   *     svgElement.setAttribute("aria-hidden", true);
   *
   *     const useElement = document.createElementNS(SVG_NAMESPACE, "use");
   *     useElement.setAttribute("href", `#far-face-smile`);
   *
   *     svgElement.appendChild(useElement);
   *
   *     return svgElement;
   *   }
   * });
   **/
  registerIconRenderer(fn) {
    registerIconRenderer(fn);
  }

  /**
   * Replace all occurrences of one icon with another without having to
   * resort to a custom IconRenderer. If you want to do something more
   * complicated than a simple replacement then create a new icon renderer.
   *
   * api.replaceIcon('d-tracking', 'smile-o');
   *
   **/
  replaceIcon(source, destination) {
    replaceIcon(source, destination);
  }

  /**
   * Method for decorating the `cooked` content of a post using JQuery
   *
   * You should use decorateCookedElement instead, which works without JQuery
   *
   * This method will be deprecated in future
   **/
  decorateCooked(callback, opts) {
    this.decorateCookedElement(
      (element, decoratorHelper) => callback($(element), decoratorHelper),
      opts
    );
  }

  /**
   * Used for decorating the `cooked` content of a post after it is rendered.
   *
   * @param {Function} callback - Function called to decorate a DOM node.
   *                              For stream-only decorators, this callback can return
   *                             a cleanup function that will be executed when decorated content is rerendered/removed.
   *                             The callback receives two parameters:
   *
   *                             1. element: HTMLElement to be decorated
   *                             2. decoratorHelper: Object containing helper methods for the decorator
   *
   * @param {Object} [opts] - Optional configuration object
   * @param {boolean} [opts.onlyStream=false] - If true, only decorate posts within a post stream.
   *
   * @example
   * // Add a yellow background to the decorated element
   * api.decorateCookedElement(
   *   elem => {
   *     elem.style.backgroundColor = 'yellow';
   *     // Optionally return a cleanup function
   *     return () => elem.style.backgroundColor = '';
   *   }
   * );
   *
   * @example
   * // Only decorate posts in the post-stream
   * api.decorateCookedElement(
   *   elem => { elem.classList.add('topic-post'); },
   *   { onlyStream: true }
   * );
   *
   * @example
   * // Using the decorator helper
   * api.decorateCookedElement(
   *   (elem, helper) => {
   *     const post = helper.model; // Get associated post model
   *     if (post.firstPost) {
   *       elem.classList.add('first-post');
   *     }
   *   }
   * );
   */
  decorateCookedElement(callback, opts) {
    opts = opts || {};

    callback = wrapWithErrorHandler(callback, "broken_decorator_alert");

    registerHtmlDecorator(
      callback,
      opts.onlyStream ? STREAM_HTML_DECORATOR : NON_STREAM_HTML_DECORATOR
    );

    // for backwards compatibility with plugins/themes decorating cooked elements
    // using the app events
    if (!opts.onlyStream) {
      this.onAppEvent("decorate-non-stream-cooked-element", callback);
    }
  }

  /**
   * See KeyboardShortcuts.addShortcut documentation.
   **/
  addKeyboardShortcut(shortcut, callback, opts = {}) {
    this.container
      .lookup("service:keyboard-shortcuts")
      .addShortcut(shortcut, callback, opts);
  }

  /**
   * See KeyboardShortcuts.unbind documentation.
   **/
  removeKeyboardShortcut(shortcut, callback) {
    this.container
      .lookup("service:keyboard-shortcuts")
      .unbind({ [shortcut]: callback });
  }

  /**
   * This function is used to disable a "default" keyboard shortcut. You can pass
   * an array of shortcut bindings as strings to disable them.
   *
   * Please note that this function must be called from a pre-initializer.
   *
   * Example:
   * ```
   * api.disableDefaultKeyboardShortcuts(['command+f', 'shift+c']);
   * ```
   **/
  disableDefaultKeyboardShortcuts(bindings) {
    disableDefaultKeyboardShortcuts(bindings);
  }

  /**
   * addPosterIcon(callback)
   *
   * This function is an alias of addPosterIcons, which the latter has the ability
   * to add multiple icons at once. Please refer to `addPosterIcons` for usage examples.
   **/
  addPosterIcon(cb) {
    this.addPosterIcons(cb);
  }

  /**
   * addPosterIcons(callback)
   *
   * This function can be used to add one, or multiple icons, with a link that will
   * be displayed beside a poster's name. The `callback` is called with the post's
   * user custom fields and post attributes. One or multiple icons may be rendered
   * when the callback returns an array of objects with the appropriate attributes.
   *
   * The returned object(s) each can have the following attributes:
   *
   *   icon        the font awesome icon to render
   *   emoji       an emoji icon to render
   *   className   (optional) a css class to apply to the icon
   *   url         (optional) where to link the icon
   *   title       (optional) the tooltip title for the icon on hover
   *   text        (optional) text to display alongside the emoji or icon
   *
   * ```
   * api.addPosterIcons((cfs, attrs) => {
   *   if (cfs.customer) {
   *     return { icon: 'user', className: 'customer', title: 'customer' };
   *   }
   * });
   * ```
   * or
   * * ```
   * api.addPosterIcons((cfs, attrs) => {
   *   return attrs.customers.map(({name}) => {
   *     icon: 'user', className: 'customer', title: name
   *   })
   * });
   * ```
   **/
  addPosterIcons(cb) {
    this.registerValueTransformer(
      "poster-name-icons",
      ({ value, context: { post } }) => {
        // `cb` is called with the post's user custom fields and post attributes
        // and should return an array of icon definitions.
        const definitions = makeArray(cb(post.user_custom_fields || {}, post));

        return makeArray(value).concat(definitions).filter(Boolean);
      }
    );
  }

  /**
   * @deprecated
   *
   * This function is now an alias to `api.addTrackedPostProperties`.
   * Use that function instead.
   *
   * Example:
   *
   * ```
   * // attrs.poster_age and attrs.poster_height will be present
   * api.includePostAttributes('poster_age', 'poster_height');
   * ```
   *
   **/
  includePostAttributes(...attributes) {
    deprecated(
      "`api.includePostAttributes` has been deprecated. Use `api.addTrackedPostProperties` instead.",
      {
        since: "v3.5.0.beta1-dev",
        url: "https://meta.discourse.org/t/372063/1",
      }
    );

    this.addTrackedPostProperties(...attributes);
  }

  /**
   * Adds tracked properties to the post model.
   *
   * This method is used to mark properties as tracked for post updates.
   *
   * You'll need to do this if you've added properties to a Post and need them to be
   * automatically updated in the UI when there are changes in the model.
   *
   * @param {...string} names - The names of the properties to be tracked.
   */
  addTrackedPostProperties(...names) {
    names.forEach((name) => _addTrackedPostProperty(name));
  }

  /**
   * Adds tracked properties to the topic model.
   *
   * This method is used to mark properties as tracked for topic updates.
   *
   * You'll need to do this if you've added properties to a Topic and need them to be
   * automatically updated in the UI when there are changes in the model.
   *
   * @param {...string} names - The names of the properties to be tracked.
   */
  addTrackedTopicProperties(...names) {
    names.forEach((name) => _addTrackedTopicProperty(name));
  }

  /**
   * Adds a tracked data field to a store model, so a property your plugin adds
   * (e.g. one included in the server payload) is reactive in the UI.
   *
   * Must be called from a pre-initializer, before the model is first looked up.
   *
   * @param {string} modelName - The model's resolver name, e.g. "bookmark".
   * @param {string} name - The name of the field to add.
   * @param {Object} [options]
   * @param {(*|Function)} [options.defaultValue] - Value when the server omits
   *   the field (default `undefined`). A function runs per instance at
   *   construction — before the payload (server wins) and too early for create
   *   args — for per-record mutable defaults, e.g. `() => ({})`.
   * @param {("array"|"object"|"set")} [options.type] - Store the field as a
   *   reactive collection, created fresh per instance so it is never shared.
   * @param {boolean} [options.resettable] - Requires a function `defaultValue`;
   *   resets to it when the derived value changes, and a manual assignment
   *   sticks until then.
   *
   * @example
   * api.addModelField("bookmark", "is_pinned", { defaultValue: false });
   * api.addModelField("post", "comments", { type: "array" });
   * api.addModelField("post", "polls_votes", { type: "object" });
   * api.addModelField("post", "meta", { defaultValue: () => ({}) });
   * api.addModelField("composer", "createAsPostVoting", {
   *   resettable: true,
   *   defaultValue() {
   *     return !!this.category?.create_as_post_voting_default;
   *   },
   * });
   */
  addModelField(modelName, name, options = {}) {
    const klass = this._resolveModelClass(modelName, { stamp: true });
    if (!klass) {
      return;
    }

    if (options.resettable) {
      if (typeof options.defaultValue !== "function") {
        throw new Error(
          "addModelField: `resettable` requires `defaultValue` to be a function (the initializer to reset to)."
        );
      }
      defineModelResettableField(klass, name, options.defaultValue);
    } else {
      registerModelField(modelName, name, options);
    }
  }

  /**
   * Adds an accessor (getter and/or setter) to a store model.
   *
   * Defined on the prototype (works in templates and with autotracking). For a
   * single side, prefer `addModelGetter` / `addModelSetter`.
   *
   * Must be called from a pre-initializer, before the model is first looked up.
   *
   * @param {string} modelName - The model's resolver name, e.g. "bookmark".
   * @param {string} name - The name of the property to add.
   * @param {Object} accessor
   * @param {Function} [accessor.get] - Getter, called with the instance as `this`.
   * @param {Function} [accessor.set] - Setter, called with the new value.
   *
   * @example
   * api.addModelAccessor("post", "polls", {
   *   get() {
   *     return this._polls;
   *   },
   *   set(value) {
   *     this._polls = value;
   *   },
   * });
   */
  addModelAccessor(modelName, name, accessor) {
    const klass = this._resolveModelClass(modelName);
    if (klass) {
      defineModelAccessor(klass, name, accessor);
    }
  }

  /**
   * Adds a getter (computed/derived property) to a store model. Shorthand for
   * `addModelAccessor` with only a getter.
   *
   * Must be called from a pre-initializer, before the model is first looked up.
   *
   * @param {string} modelName - The model's resolver name, e.g. "bookmark".
   * @param {string} name - The name of the getter to add.
   * @param {Function} getter - Called with the model instance as `this`.
   *
   * @example
   * api.addModelGetter("bookmark", "isPinned", function () {
   *   return this.is_pinned;
   * });
   */
  addModelGetter(modelName, name, getter) {
    this.addModelAccessor(modelName, name, { get: getter });
  }

  /**
   * Adds a setter to a store model. Shorthand for `addModelAccessor` with only a
   * setter.
   *
   * Must be called from a pre-initializer, before the model is first looked up.
   *
   * @param {string} modelName - The model's resolver name, e.g. "topic".
   * @param {string} name - The name of the setter to add.
   * @param {Function} setter - Called with the new value; the instance is `this`.
   *
   * @example
   * api.addModelSetter("topic", "related_topics", function (value) {
   *   this._relatedTopicsRecords = value;
   * });
   */
  addModelSetter(modelName, name, setter) {
    this.addModelAccessor(modelName, name, { set: setter });
  }

  /**
   * Adds an instance method to a store model.
   *
   * Must be called from a pre-initializer, before the model is first looked up.
   *
   * @param {string} modelName - The model's resolver name, e.g. "bookmark".
   * @param {string} name - The name of the method to add.
   * @param {Function} fn - Called with the model instance as `this`.
   *
   * @example
   * api.addModelMethod("bookmark", "togglePin", function () {
   *   this.is_pinned = !this.is_pinned;
   * });
   */
  addModelMethod(modelName, name, fn) {
    const klass = this._resolveModelClass(modelName);
    if (klass) {
      defineModelMethod(klass, name, fn);
    }
  }

  /**
   * Registers a property to include in a model's save payload.
   *
   * For persisting a field your plugin adds (see `addModelField`). By default
   * `instance[name]` is sent; pass `valueFn` (bound to the instance) to send a
   * computed value, e.g. to nest data under `custom_fields`.
   *
   * Must be called from a pre-initializer, before the model is first looked up.
   *
   * @param {string} modelName - The model's resolver name, e.g. "group".
   * @param {string} name - The name of the property to include when saving.
   * @param {Function} [valueFn] - Returns the value to send; called with the
   *   model instance as `this`.
   *
   * @example
   * api.addModelSaveProperty("group", "assignable_level");
   * api.addModelSaveProperty("group", "custom_fields", function () {
   *   return { my_field: this.my_field };
   * });
   */
  addModelSaveProperty(modelName, name, valueFn) {
    if (this._resolveModelClass(modelName, { stamp: true })) {
      registerModelSaveProperty(modelName, name, valueFn);
    }
  }

  /**
   * Registers a callback to run on a model's lifecycle.
   *
   * Runs with the model instance as `this`, replacing `modifyClass` overrides
   * of `init`/`save`. `init` fires per instance after create args are applied.
   * Create/update events fire on the standard store save path (and for `Group`,
   * which also fires destroy); other models with a custom `save()` (e.g.
   * `Category`) don't. `after*` callbacks returning a promise are awaited.
   *
   * Must be called from a pre-initializer, before the model is first looked up.
   *
   * @param {string} modelName - The model's resolver name, e.g. "bookmark".
   * @param {("init"|"beforeCreate"|"afterCreate"|"beforeUpdate"|"afterUpdate"|"beforeDestroy"|"afterDestroy"|"beforeSave"|"afterSave")} event -
   *   The lifecycle event. "beforeSave"/"afterSave" fire for both create and update.
   * @param {Function} fn - Called with nothing (init/destroy), the request props
   *   (before create/update), or the server result (after*).
   *
   * @example
   * api.addModelCallback("bookmark", "afterSave", function (result) {
   *   // ...
   * });
   */
  addModelCallback(modelName, event, fn) {
    if (this._resolveModelClass(modelName, { stamp: true })) {
      registerModelCallback(modelName, event, fn);
    }
  }

  /**
   * Decommissioned API
   **/
  addPostMenuButton() {
    // eslint-disable-next-line no-console
    console.error(
      "`api.addPostMenuButton`: This API was decommissioned. Use the value transformer `post-menu-buttons` instead."
    );
  }

  /**
   * Add a new button in the post admin menu.
   *
   * Example:
   *
   * ```
   * api.addPostAdminMenuButton((post) => {
   *   return {
   *     action: () => {
   *       alert('You clicked on the coffee button!');
   *     },
   *     icon: 'mug-saucer',
   *     className: 'hot-coffee',
   *     label: 'coffee.title',
   *   };
   * });
   * ```
   **/
  addPostAdminMenuButton(callback) {
    this.container
      .lookup("service:admin-post-menu-buttons")
      .addButton(callback);
  }

  /**
   * Add a new button in the topic admin menu.
   *
   * Optionally pass a `section` to group buttons under a labelled subheader.
   * Adjacent buttons sharing the same `section.id` are grouped together;
   * provide either an i18n `label` key or a pre-translated `translatedLabel`.
   *
   * Example:
   *
   * ```
   * api.addTopicAdminMenuButton((topic) => {
   *   return {
   *     action: () => {
   *       alert('You clicked on the coffee button!');
   *     },
   *     icon: 'mug-saucer',
   *     className: 'hot-coffee',
   *     label: 'coffee.title',
   *     section: { id: 'beverages', label: 'beverages.title' },
   *   };
   * });
   * ```
   **/
  addTopicAdminMenuButton(callback) {
    this.container
      .lookup("service:admin-topic-menu-buttons")
      .addButton(callback);
  }

  /**
   * Decommissioned API
   **/
  removePostMenuButton() {
    // eslint-disable-next-line no-console
    console.error(
      "`api.removePostMenuButton`: This API was decommissioned. Use the value transformer `post-menu-buttons` instead."
    );
  }

  /**
   * Decommissioned API
   **/
  replacePostMenuButton() {
    // eslint-disable-next-line no-console
    console.error(
      "`api.replacePostMenuButton`: This API was decommissioned. Use the value transformer `post-menu-buttons` instead."
    );
  }

  /**
   * A hook that is called when the editor toolbar is created. You can
   * use this to add custom editor buttons.
   *
   * Example:
   *
   * ```
   * api.onToolbarCreate(toolbar => {
   *   toolbar.addButton({
   *     id: 'pop-text',
   *     group: 'extras',
   *     icon: 'bolt',
   *     action: 'makeItPop',
   *     title: 'pop_format.title'
   *   });
   * });
   **/
  onToolbarCreate(callback) {
    addToolbarCallback(callback);
  }

  /**
   * Add a new button in the composer's toolbar options popup menu.
   *
   * @callback action
   * @param {Object} toolbarEvent - A toolbar event object.
   * @param {function} toolbarEvent.applySurround - Surrounds the selected text with the given text.
   * @param {function} toolbarEvent.addText - Append the given text to the selected text in the composer.
   *
   * @callback condition
   * @param {Object} composer - The composer service object.
   * @returns {boolean} - Whether the button should be displayed.
   *
   * @param {Object} opts - An Object.
   * @param {string} [opts.menu] - Target menu: 'list' for list dropdown, omit for options popup (default).
   * @param {string} [opts.name] - Unique identifier for the option.
   * @param {string} opts.icon - The name of the FontAwesome icon to display for the button.
   * @param {string} opts.label - The I18n translation key for the button's label.
   * @param {string} opts.shortcut - The keyboard shortcut to apply, NOTE: this will unconditionally add CTRL/META key (eg: m means CTRL+m).
   * @param {action} opts.action - The action to perform when the button is clicked.
   * @param {condition} opts.condition - A condition that must be met for the button to be displayed.
   *
   * @example
   * api.addComposerToolbarPopupMenuOption({
   *   action: (toolbarEvent) => {
   *     toolbarEvent.applySurround("**", "**");
   *   },
   *   icon: 'far-bold',
   *   label: 'composer.bold_some_text',
   *   shortcut: 'm',
   *   condition: (composer) => {
   *     return composer.editingPost;
   *   }
   * });
   *
   * @example
   * // Add option to list dropdown
   * api.addComposerToolbarPopupMenuOption({
   *   menu: 'list',
   *   name: 'my-custom-list',
   *   icon: 'list-check',
   *   label: 'my_plugin.custom_list',
   *   action: (toolbarEvent) => {
   *     toolbarEvent.applyList("- [x] ", "list_item");
   *   }
   * });
   **/
  addComposerToolbarPopupMenuOption(opts) {
    addPopupMenuOption(opts);
  }

  addToolbarPopupMenuOptionsCallback(opts) {
    deprecated(
      "`addToolbarPopupMenuOptionsCallback` has been renamed to `addComposerToolbarPopupMenuOption`",
      {
        id: "discourse.add-toolbar-popup-menu-options-callback",
        since: "3.2",
      }
    );

    this.addComposerToolbarPopupMenuOption(opts);
  }

  /**
   * Register a custom item in the composer-actions dropdown (the menu next
   * to the composer title that switches between Reply, Create Topic, etc.).
   *
   * @param {Object} opts
   * @param {string} opts.id - Unique identifier for the item.
   * @param {string} opts.label - I18n key for the item's display name.
   * @param {string} [opts.description] - Optional I18n key for the item's description text.
   * @param {string} [opts.icon] - Optional icon name.
   * @param {Function} [opts.condition] - `(composerActionsComponent) => boolean`. Item is shown when this returns truthy, or when omitted.
   * @param {Function} opts.action - `(composerModel, composerActionsComponent) => void`. Called when the user picks the item.
   *
   * @example
   * api.addComposerAction({
   *   id: "create_event",
   *   label: "discourse_post_event.composer_actions.create_event.label",
   *   description: "discourse_post_event.composer_actions.create_event.desc",
   *   icon: "calendar-days",
   *   condition: (component) =>
   *     component.composerModel?.category?.isType("events"),
   *   action: (composerModel) => composerModel.set("creatingEvent", true),
   * });
   */
  addComposerAction(opts) {
    registerComposerAction(opts);
  }

  /**
   * Called whenever the "page" changes. This allows us to set up analytics
   * and other tracking.
   *
   * To get notified when the page changes, you can install a hook like so:
   *
   * ```javascript
   * api.onPageChange((url, title) => {
   *   console.log('the page changed to: ' + url + ' and title ' + title);
   * });
   * ```
   **/
  onPageChange(fn) {
    const callback = wrapWithErrorHandler(fn, "broken_page_change_alert");
    this.onAppEvent("page:changed", (data) => callback(data.url, data.title));
  }

  /**
   * Listen for a triggered `AppEvent` from Discourse.
   *
   * ```javascript
   * api.onAppEvent('inserted-custom-html', () => {
   *   console.log('a custom footer was rendered');
   * });
   * ```
   **/
  onAppEvent(name, fn) {
    const appEvents = this._lookupContainer("service:app-events");
    appEvents && appEvents.on(name, fn);
  }

  /**
   * Registers a function to generate custom avatar CSS classes
   * for a particular user.
   *
   * Takes a function that will accept a user as a parameter
   * and return an array of CSS classes to apply.
   *
   * ```javascript
   * api.customUserAvatarClasses(user => {
   *   if (get(user, 'primary_group_name') === 'managers') {
   *     return ['managers'];
   *   }
   * });
   **/
  customUserAvatarClasses(fn) {
    registerCustomAvatarHelper(fn);
  }

  /**
   * Allows you to disable suppression of similar username / names on posts
   * If a user has the username bob.bob and the name Bob Bob, one of the two
   * will be suppressed depending on prioritize_username_in_ux.
   * This allows you to override core behavior
   **/
  disableNameSuppressionOnPosts() {
    this.registerValueTransformer(
      "post-meta-data-poster-name-suppress-similar-name",
      () => true
    );
  }

  /**
   * Registers a callback that will be invoked when the server calls
   * Post#publish_change_to_clients! Please ensure your type does not
   * match acted, revised, rebaked, recovered, created, move_to_inbox
   * or archived
   *
   * callback will be called with topicController and Message
   *
   * Example:
   *
   * api.registerCustomPostMessageCallback("applied_color", (topicController, message) => {
   *   let stream = topicController.get("model.postStream");
   *   // etc
   * });
   */
  registerCustomPostMessageCallback(type, callback) {
    registerCustomPostMessageCallback1(type, callback);
  }

  /**
   * Registers a callback that will be evaluated when infinite scrolling would cause
   * more notifications to be loaded. This can be used to prevent loading more unless
   * a specific condition is met.
   *
   * Example:
   *
   * api.addBeforeLoadMoreNotificationsCallback((controller) => {
   *   return controller.allowLoadMore;
   * });
   */
  addBeforeLoadMoreNotificationsCallback(fn) {
    addBeforeLoadMoreNotificationsCallback(fn);
  }

  /**
   * Prevents a specific post from being cloaked during scroll.
   *
   * This is useful, for example, for posts that apply customizations that hold state which
   * would be lost if the nodes were removed from the DOM, e.g., a playing video.
   *
   * Note that the set of prevented posts is reset whenever the topic being displayed changes.
   *
   * @param {number} postId - The ID of the post to prevent from cloaking
   * @param {boolean} prevent - Whether to prevent (true) or allow (false) cloaking
   *
   * @example
   * ```javascript
   * api.preventCloak(1234); // Prevent post 1234 from being cloaked
   * api.preventCloak(1234, false); // Allow post 1234 to be cloaked again
   * ```
   **/
  preventCloak(postId, prevent = true) {
    preventCloaking(postId, prevent);
  }

  /**
   * Adds a pluralization to the store
   *
   * Example:
   *
   * ```javascript
   * api.addStorePluralization('mouse', 'mice');
   * ```
   *
   * ```javascript
   * this.store.find('mouse');
   * ```
   * will issue a request to `/mice.json`
   **/
  addStorePluralization(thing, plural) {
    const store = this._lookupContainer("service:store");
    store && store.addPluralization(thing, plural);
  }

  /**
   * @deprecated
   *
   * Register a Connector class for a particular outlet and connector.
   *
   * For example, if the outlet is `user-profile-primary` and your connector
   * template is called `my-connector.hbs`:
   *
   * ```javascript
   * api.registerConnectorClass('user-profile-primary', 'my-connector', {
   *   shouldRender(args, component) {
   *     return component.siteSettings.my_plugin_enabled;
   *   }
   * });
   * ```
   *
   * This API is deprecated. See renderInOutlet instead.
   *
   **/
  registerConnectorClass(outletName, connectorName, klass) {
    extraConnectorClass(`${outletName}/${connectorName}`, klass);
  }

  /**
   * Register a component to be rendered in a particular outlet.
   *
   * For example, if the outlet is `user-profile-primary`, you could register
   * a component like
   *
   * ```javascript
   * import MyComponent from "discourse/plugins/my-plugin/components/my-component";
   * api.renderInOutlet('user-profile-primary', MyComponent);
   * ```
   *
   * Alternatively, a component could be defined inline using gjs:
   *
   * ```javascript
   * api.renderInOutlet('user-profile-primary', <template>Hello world</template>);
   * ```
   *
   * Note that when passing a component definition to an outlet like this, the default
   * `@connectorTagName` of the outlet is not used. If you need a wrapper element, you'll
   * need to add it to your component's template.
   *
   * @param {string} outletName - Name of plugin outlet to render into
   * @param {Component} klass - Component class definition to be rendered
   *
   */
  renderInOutlet(outletName, klass) {
    extraConnectorComponent(outletName, klass);
  }

  /**
   * Render a component before the content of a wrapper outlet and does not override it's content
   *
   * For example, if the outlet is `discovery-list-area`, you could register
   * a component like
   *
   * ```javascript
   * import MyComponent from "discourse/plugins/my-plugin/components/my-component";
   * api.renderBeforeWrapperOutlet('discovery-list-area', MyComponent);
   * ```
   *
   * Alternatively, a component could be defined inline using gjs:
   *
   * ```javascript
   * api.renderBeforeWrapperOutlet('discovery-list-area', <template>Before the outlet</template>);
   * ```
   *
   * Note:
   * - the content of the outlet is not overridden when using this API, and unlike the main outlet,
   *   multiple connectors can be registered for the same outlet.
   * - this API only works with wrapper outlets. It won't have any effect on standard outlets.
   * - when passing a component definition to an outlet like this, the default
   * `@connectorTagName` of the outlet is not used. If you need a wrapper element, you'll
   * need to add it to your component's template.
   *
   * @param {string} outletName - Name of plugin outlet to render into
   * @param {Component} klass - Component class definition to be rendered
   *
   */
  renderBeforeWrapperOutlet(outletName, klass) {
    this.renderInOutlet(`${outletName}__before`, klass);
  }

  /**
   * Render a component after the content of a wrapper outlet and does not override it's content
   *
   * For example, if the outlet is `discovery-list-area`, you could register
   * a component like
   *
   * ```javascript
   * import MyComponent from "discourse/plugins/my-plugin/components/my-component";
   * api.renderAfterWrapperOutlet('discovery-list-area', MyComponent);
   * ```
   *
   * Alternatively, a component could be defined inline using gjs:
   *
   * ```javascript
   * api.renderAfterWrapperOutlet('discovery-list-area', <template>After the outlet</template>);
   * ```
   *
   * Note:
   * - the content of the outlet is not overridden when using this API, and unlike the main outlet,
   *   multiple connectors can be registered for the same outlet.
   * - this API only works with wrapper outlets. It won't have any effect on standard outlets.
   * - when passing a component definition to an outlet like this, the default
   * `@connectorTagName` of the outlet is not used. If you need a wrapper element, you'll
   * need to add it to your component's template.
   *
   * @param {string} outletName - Name of plugin outlet to render into
   * @param {Component} klass - Component class definition to be rendered
   *
   */
  renderAfterWrapperOutlet(outletName, klass) {
    this.renderInOutlet(`${outletName}__after`, klass);
  }

  /**
   * Register a button to display at the bottom of a topic
   *
   * ```javascript
   * api.registerTopicFooterButton({
   *   id: "flag",
   *   icon: "flag",
   *   action(context) { console.log(context.get("topic.id")) },
   * });
   * ```
   **/
  registerTopicFooterButton(buttonOptions) {
    registerTopicFooterButton(buttonOptions);
  }

  /**
   * Register a dropdown to display at the bottom of a topic, desktop only
   *
   * ```javascript
   * api.registerTopicFooterDropdown({
   *   id: "my-button",
   *   content() { return [{id: 1, name: "foo"}] },
   *   action(itemId) { console.log(itemId) },
   * });
   * ```
   **/
  registerTopicFooterDropdown(dropdownOptions) {
    registerTopicFooterDropdown(dropdownOptions);
  }

  /**
   * Register a desktop notification handler
   *
   * ```javascript
   * api.registerDesktopNotificationHandler((data, siteSettings, user) => {
   *   // Do something!
   * });
   * ```
   **/
  registerDesktopNotificationHandler(handler) {
    registerDesktopNotificationHandler(handler);
  }

  /**
   * Register a small icon to be used for custom small post actions
   *
   * ```javascript
   * api.registerPostSmallActionIcon('assign-to', 'user-add');
   * ```
   **/
  addPostSmallActionIcon(key, icon) {
    this.registerValueTransformer(
      "post-small-action-icon",
      ({ value, context: { code } }) => (key === code ? icon : value)
    );
  }

  /**
   * Register a small action code to be used for small post actions containing a link to a group
   *
   * ```javascript
   * api.addGroupPostSmallActionCode('group_assigned');
   * ```
   **/
  addGroupPostSmallActionCode(actionCode) {
    addGroupPostSmallActionCode(actionCode);
  }

  /**
   * Adds a callback to be called before rendering any small action post
   * that returns custom classes to add to the small action post
   *
   * ```javascript
   * addPostSmallActionClassesCallback(post => {
   *   if (post.actionCode.includes("group")) {
   *     return ["group-small-post"];
   *   }
   * });
   * ```
   **/
  addPostSmallActionClassesCallback(callback) {
    this.registerValueTransformer(
      "post-small-action-class",
      ({ value, context: { post } }) => [
        ...makeArray(value),
        ...makeArray(callback(post)),
      ]
    );
  }

  /**
   * Register an additional query param with topic discovery,
   * this allows for filters on the topic list
   *
   **/
  addDiscoveryQueryParam(param, options) {
    addDiscoveryQueryParam(param, options);
  }

  /**
   * Register a callback to be called every time tags render
   * highest priority callbacks are called first
   * example:
   *
   * callback = function(topic, params) {
   *    if (topic.get("created_at") < "2000-00-01") {
   *      return "<span class='discourse-tag'>ANCIENT</span>"
   *    }
   * }
   *
   * api.addTagsHtmlCallback(callback, {priority: 100});
   *
   **/
  addTagsHtmlCallback(callback, options) {
    addTagsHtmlCallback(callback, options);
  }

  /**
   * Adds a glyph to the legacy user menu after bookmarks
   * WARNING: there is limited space there
   *
   * example:
   *
   * api.addUserMenuGlyph({
   *    title: 'awesome.label',
   *    className: 'my-class',
   *    icon: 'my-icon',
   *    data: { url: `/some/path` },
   * });
   *
   * To customize the new user menu, see api.registerUserMenuTab
   */
  addUserMenuGlyph() {
    deprecated(
      "addUserMenuGlyph has been removed. Use api.registerUserMenuTab instead.",
      { id: "discourse.add-user-menu-glyph" }
    );
  }

  /**
   * Adds a callback to be called before rendering any post that
   * that returns custom classes to add to the post
   *
   * Example:
   *
   * addPostClassesCallback((attrs) => {if (attrs.post_number == 1) return ["first"];})
   **/
  addPostClassesCallback(callback) {
    this.registerValueTransformer(
      "post-class",
      ({ value, context: { post } }) => [
        ...makeArray(value),
        ...makeArray(callback(post)),
      ]
    );
  }

  /**
   * Adds a callback to be called before rendering a topic participant that
   * that returns custom classes to add to the participant element
   *
   * Example:
   *
   * addTopicParticipantClassesCallback((attrs) => {if (attrs.primary_group_name == "moderator") return ["important-participant"];})
   **/
  addTopicParticipantClassesCallback(callback) {
    addTopicParticipantClassesCallback(callback);
  }

  /**
   * Adds a callback when validating the value of a custom user field in the signup form.
   *
   * If the validation is intended to fail, the callback should return an Ember Object with the
   * following properties: `failed`, `reason`, and `element`.
   *
   * In the case of a failed validation, the `reason` will be displayed to the user
   * and the form will not be submitted.
   *
   *
   * Example:
   *
   * addCustomUserFieldValidationCallback((userField) => {
   *   if (userField.field.name === "my custom user field" && userField.value === "foo") {
   *     return EmberObject.create({
   *       failed: true,
   *       reason: I18n.t("value_can_not_be_foo"),
   *       element: userField.field.element,
   *     });
   *   }
   * });
   **/

  addCustomUserFieldValidationCallback(callback) {
    addCustomUserFieldValidationCallback(callback);
  }

  /**
   *
   * Adds a new item in the navigation bar. Returns the NavItem object created.
   *
   * Example:
   *
   * addNavigationBarItem({
   *   name: "discourse",
   *   displayName: "Discourse"
   *   href: "https://www.discourse.org",
   * })
   *
   * An optional `customFilter` callback can be included to not display the
   * nav item on certain routes
   *
   * An optional `init` callback can be included to run custom code on menu
   * init
   *
   * Example:
   *
   * addNavigationBarItem({
   *   name: "link-to-bugs-category",
   *   displayName: "bugs"
   *   href: "/c/bugs",
   *   init: (navItem, category) => { if (category) { navItem.set("category", category)  } }
   *   customFilter: (category, args, router) => { return category && category.displayName !== 'bug' }
   *   customHref: (category, args, router) => {  if (category && category.displayName) === 'not-a-bug') return "/a-feature"; },
   *   before: "top",
   *   forceActive: (category, args, router) => router.currentURL === "/a/b/c/d",
   * })
   */
  addNavigationBarItem(item) {
    if (!item["name"]) {
      // eslint-disable-next-line no-console
      console.warn(
        consolePrefix(),
        "A 'name' is required when adding a Navigation Bar Item.",
        item
      );
    } else {
      const customHref = item.customHref;
      if (customHref) {
        const router = this.container.lookup("service:router");
        item.customHref = function (category, args) {
          return customHref(category, args, router);
        };
      }

      const customFilter = item.customFilter;
      if (customFilter) {
        const router = this.container.lookup("service:router");
        item.customFilter = function (category, args) {
          return customFilter(category, args, router);
        };
      }

      const forceActive = item.forceActive;
      if (forceActive) {
        const router = this.container.lookup("service:router");
        item.forceActive = function (category, args) {
          return forceActive(category, args, router);
        };
      }

      const init = item.init;
      if (init) {
        const router = this.container.lookup("service:router");
        item.init = function (navItem, category, args) {
          init(navItem, category, args, router);
        };
      }

      addNavItem(item);
    }
  }

  /**
   *
   * Registers a function that will format a username when displayed. This will not
   * be applied when the username is used as an `id` or in URL strings.
   *
   * Example:
   *
   * ```
   * // display usernames in UPPER CASE
   * api.formatUsername(username => username.toUpperCase());
   *
   * ```
   *
   **/
  formatUsername(fn) {
    replaceFormatter(fn);
  }

  /**
   *
   * Access SelectKit plugin api
   *
   * Example:
   *
   * api.modifySelectKit("topic-footer-mobile-dropdown").appendContent(() => [{
   *   name: "discourse",
   *   id: 1
   * }])
   */
  modifySelectKit(pluginApiKey) {
    return modifySelectKit(pluginApiKey);
  }

  /**
   *
   * Registers a function that can inspect and modify the data that
   * will be sent to Google Tag Manager when a page changed event is triggered.
   *
   * Example:
   *
   * api.addGTMPageChangedCallback( gtmData => gtmData.locale = I18n.currentLocale() )
   *
   */
  addGTMPageChangedCallback(fn) {
    addGTMPageChangedCallback(fn);
  }

  /**
   *
   * Registers a function that can add a new sharing source
   *
   * Example:
   *
   * // read discourse/lib/sharing for options
   * api.addSharingSource(options)
   *
   */
  addSharingSource(options) {
    Sharing.addSharingId(options.id);
    Sharing.addSource(options);
  }

  /**
   * Registers a function to handle uploads for specified file types.
   * The normal uploading functionality will be bypassed if function returns
   * a falsy value.
   *
   * Example:
   *
   * api.addComposerUploadHandler(["mp4", "mov"], (files, editor) => {
   *   files.forEach((file) => {
   *     console.log("Handling upload for", file.name);
   *   });
   * })
   */
  addComposerUploadHandler(extensions, method) {
    addComposerUploadHandler(extensions, method);
  }

  /**
   * Registers a pre-processor for file uploads in the form
   * of an Uppy preprocessor plugin.
   *
   * See https://uppy.io/docs/writing-plugins/ for the Uppy
   * documentation, but other examples of preprocessors in core
   * can be found in UppyMediaOptimization and UppyChecksum.
   *
   * Useful for transforming to-be uploaded files client-side.
   *
   * Example:
   *
   * api.addComposerUploadPreProcessor(UppyMediaOptimization, ({ composerModel, composerElement, capabilities, isMobileDevice }) => {
   *   return {
   *     composerModel,
   *     composerElement,
   *     capabilities,
   *     isMobileDevice,
   *     someOption: true,
   *     someFn: () => {},
   *   };
   * });
   *
   * @param {BasePlugin} pluginClass The uppy plugin class to use for the preprocessor.
   * @param {Function} optionsResolverFn This function should return an object which is passed into the constructor
   *                                     of the uppy plugin as the options argument. The object passed to the function
   *                                     contains references to the composer model, element, the capabilities of the
   *                                     browser, and isMobileDevice.
   */
  addComposerUploadPreProcessor(pluginClass, optionsResolverFn) {
    addComposerUploadPreProcessor(pluginClass, optionsResolverFn);
  }

  /**
   * Registers a function to generate Markdown after a file has been uploaded.
   *
   * Example:
   *
   * api.addComposerUploadMarkdownResolver(upload => {
   *   return `_uploaded ${upload.original_filename}_`;
   * })
   */
  addComposerUploadMarkdownResolver(resolver) {
    addComposerUploadMarkdownResolver(resolver);
  }

  /**
   * Registers a function to decorate each autocomplete usernames.
   *
   * Example:
   *
   * api.addUsernameSelectorDecorator(username => {
   *   return `<span class="status">[is_away]</class>`;
   * })
   */
  addUsernameSelectorDecorator(decorator) {
    addUsernameSelectorDecorator(decorator);
  }

  /**
   * Registers a "beforeSave" function on the composer. This allows you to
   * implement custom logic that will happen before the user makes a post.
   * The passed function is expected to return a promise.
   *
   * Example:
   *
   * api.composerBeforeSave(() => {
   *   return new Promise(() => {
   *     console.log("Before saving, do something!")
   *   })
   * })
   */
  composerBeforeSave(method) {
    Composer.reopen({ beforeSave: method });
  }

  /**
   * Registers a callback function to handle the composer save errors.
   * This allows you to implement custom logic that will happen before
   * the raw error is presented to the user.
   * The passed function is expected to return true if the error was handled,
   * false otherwise.
   *
   * Example:
   *
   * api.addComposerSaveErrorCallback((error) => {
   *   if (error == "my_error") {
   *      //handle error
   *      return true;
   *   }
   *   return false;
   * })
   */
  addComposerSaveErrorCallback(callback) {
    addComposerSaveErrorCallback(callback);
  }

  /**
   * Adds a field to topic edit serializer
   *
   * Example:
   *
   * api.serializeToTopic('key_set_in_model', 'field_name_in_payload');
   *
   * to keep both of them same
   * api.serializeToTopic('field_name');
   *
   */
  serializeToTopic(fieldName, property) {
    Composer.serializeToTopic(fieldName, property);
  }

  /**
   * Adds a field to draft serializer
   *
   * Example:
   *
   * api.serializeToDraft('key_set_in_model', 'field_name_in_payload');
   *
   * to keep both of them same
   * api.serializeToDraft('field_name');
   *
   */
  serializeToDraft(fieldName, property) {
    Composer.serializeToDraft(fieldName, property);
  }

  /**
   * Adds a field to composer create serializer
   *
   * Example:
   *
   * api.serializeOnCreate('key_set_in_model', 'field_name_in_payload');
   *
   * to keep both of them same
   * api.serializeOnCreate('field_name');
   *
   */
  serializeOnCreate(fieldName, property) {
    Composer.serializeOnCreate(fieldName, property);
  }

  /**
   * Adds a field to composer update serializer
   *
   * Example:
   *
   * api.serializeOnUpdate('key_set_in_model', 'field_name_in_payload');
   *
   * to keep both of them same
   * api.serializeOnUpdate('field_name');
   *
   */
  serializeOnUpdate(fieldName, property) {
    Composer.serializeOnUpdate(fieldName, property);
  }

  /**
   * Registers a criteria that can be used as default topic order on category
   * pages.
   *
   * Example:
   *
   * categorySortCriteria("votes");
   */
  addCategorySortCriteria(criteria) {
    this.registerValueTransformer("category-sort-orders", ({ value }) => {
      value.push(criteria);
    });
  }

  /**
   * Card contents mixin will add a listener to elements matching this selector
   * that will open card contents when a mention of div with the correct data attribute
   * is clicked
   */
  addCardClickListenerSelector(selector) {
    addCardClickListenerSelector(selector);
  }

  /**
   * Registers a renderer that overrides the display of category links.
   *
   * Example:
   *
   * function testReplaceRenderer(category, opts) {
   *   return "Hello World";
   * }
   * api.replaceCategoryLinkRenderer(categoryIconsRenderer);
   **/
  replaceCategoryLinkRenderer(fn) {
    replaceCategoryLinkRenderer(fn);
  }

  /**
   * Registers a renderer that overrides the display of a tag.
   *
   * Example:
   *
   * function testTagRenderer(tag, params) {
   *   const visibleName = escapeExpression(tag);
   *   return `testing: ${visibleName}`;
   * }
   * api.replaceTagRenderer(testTagRenderer);
   **/
  replaceTagRenderer(fn) {
    replaceTagRenderer(fn);
  }

  /**
   * Register a custom last unread url for a topic list item.
   * If a non-null value is returned, it will be used right away.
   *
   * Example:
   *
   * function testLastUnreadUrl(context) {
   *   return context.urlForPostNumber(1);
   * }
   * api.registerCustomLastUnreadUrlCallback(testLastUnreadUrl);
   **/
  registerCustomLastUnreadUrlCallback(fn) {
    registerCustomLastUnreadUrlCallback(fn);
  }

  /**
   * Registers custom languages for use with HighlightJS.
   *
   * See https://highlightjs.readthedocs.io/en/latest/language-guide.html
   * for instructions on how to define a new language for HighlightJS.
   * Build minified language file by running "node tools/build.js -t cdn" in the HighlightJS repo
   * and use the minified output as the registering function.
   *
   * Example:
   *
   * let aLang = function(e){return{cI:!1,c:[{bK:"GET HEAD PUT POST DELETE PATCH",e:"$",c:[{cN:"title",b:"/?.+"}]},{b:"^{$",e:"^}$",sL:"json"}]}}
   * api.registerHighlightJSLanguage("kibana", aLang);
   **/
  registerHighlightJSLanguage(name, fn) {
    registerHighlightJSLanguage(name, fn);
  }

  /**
   * Registers custom HighlightJS plugins.
   *
   * See https://highlightjs.readthedocs.io/en/latest/plugin-api.html
   * for instructions on how to define a new plugin for HighlightJS.
   * This API exposes the Function Based Plugins interface
   *
   * Example:
   *
   * ```javascript
   * let aPlugin = {
   *   "after:highlightElement": ({ el, result, text }) => {
   *     console.log(el);
   *   }
   * }
   * api.registerHighlightJSPlugin(aPlugin);
   **/
  registerHighlightJSPlugin(plugin) {
    registerHighlightJSPlugin(plugin);
  }

  /**
   * Adds global notices to display.
   *
   * Example:
   *
   * api.addGlobalNotice("text", "foo", { html: "<p>bar</p>" })
   **/
  addGlobalNotice(text, id, options) {
    addGlobalNotice(text, id, options);
  }

  /**
   * Used for modifying the document title count. The core count is unread notifications, and
   * the returned value from calling the passed in function will be added to this number.
   *
   * For example, to add a count
   * api.addDocumentTitleCounter(() => {
   *   return currentUser.somePluginValue;
   * })
   **/
  addDocumentTitleCounter(counterFunction) {
    addPluginDocumentTitleCounter(counterFunction);
  }

  /**
   *
   * Used for decorating the rendered HTML content of a plugin-outlet after it's been rendered
   *
   * `callback` will be called when it is time to decorate it.
   *
   * For example, to add a yellow background to a connector:
   *
   * ```
   * api.decoratePluginOutlet(
   *   "discovery-list-container-top",
   *   (elem, args) => {
   *     if (elem.classList.contains("foo")) {
   *       elem.style.backgroundColor = "yellow";
   *     }
   *   }
   * );
   * ```
   *
   * @deprecated because modifying an Ember-rendered DOM tree can lead to very unexpected errors. Use CSS or plugin outlet connectors instead
   **/
  decoratePluginOutlet(outletName, callback, opts) {
    deprecated(
      "decoratePluginOutlet is deprecated because modifying an Ember-rendered DOM tree can lead to very unexpected errors. Use CSS or plugin outlet connectors instead",
      { id: "discourse.decorate-plugin-outlet" }
    );
    addPluginOutletDecorator(outletName, callback, opts || {});
  }

  /**
   * Used to set the min and max height for the topic timeline scroll area on desktop. Pass object with min/max key value pairs.
   * Example:
   * api.setDesktopTopicTimelineScrollAreaHeight({ min: 50, max: 100 });
   **/
  setDesktopTopicTimelineScrollAreaHeight(height) {
    setDesktopScrollAreaHeight(height);
  }

  /**
   * Allows a different limit to be set for fetching recent notifications for the user menu
   *
   * Example setting limit to 5:
   * api.setUserMenuNotificationsLimit(5);
   *
   **/
  setUserMenuNotificationsLimit(limit) {
    setUserMenuNotificationsLimit(limit);
  }

  /**
   * Allows adding icons to the category-link html
   *
   * ```javascript
   * api.addCategoryLinkIcon((category) => {
   *   if (category.someProperty) {
   *     return "eye"
   *   }
   * });
   * ```
   **/
  addCategoryLinkIcon(renderer) {
    addExtraIconRenderer(renderer);
  }

  /**
   * @deprecated Use `api.headerIcons` instead
   */
  // eslint-disable-next-line no-unused-vars
  addToHeaderIcons(icon) {
    // eslint-disable-next-line no-console
    console.error(
      consolePrefix(),
      `api.addToHeaderIcons: This API was decommissioned. Use api.headerIcons instead.`
    );
  }

  /**
   * Set a callback function to specify the URL used in the home logo.
   *
   * This API allows you change the URL of the home logo. As it receives a callback function, you can
   * dynamically change the URL based on the current user, site settings, or any other context.
   *
   * Example: return a static URL
   * ```
   * api.registerHomeLogoHrefCallback(() => "https://example.com");
   * ```
   *
   * Example: return a dynamic URL based on the current user
   * ```
   * api.registerHomeLogoHrefCallback(() => {
   *   const currentUser = api.getCurrentUser();
   *   return `https://example.com/${currentUser.username}`;
   * });
   * ```
   *
   * Example: return a URL based on a theme-component setting
   * ```
   * api.registerHomeLogoHrefCallback(() => {
   *   return settings.example_logo_url_setting;
   * });
   * ```
   *
   * Example: return a URL based on the route
   * ```
   * api.registerHomeLogoHrefCallback(() => {
   *   if (api.container.lookup("service:discovery").onDiscoveryRoute) {
   *     return "https://forum.example.com/categories";
   *   }
   *
   *   return "https://forum.example.com/";
   * });
   * ```
   *
   * @param {Function} callback - A function that returns the URL to be used in the home logo.
   *
   */
  registerHomeLogoHrefCallback(callback) {
    _registerTransformer(
      "home-logo-href",
      transformerTypes.VALUE,
      ({ value }) => callback(value)
    );
  }

  /**
   * Adds an item to the quick access profile panel, before "Log Out".
   *
   * ```
   * api.addQuickAccessProfileItem({
   *   icon: "pencil",
   *   href: "/somewhere",
   *   content: I18n.t("user.somewhere")
   * })
   * ```
   *
   **/
  addQuickAccessProfileItem(item) {
    addUserMenuProfileTabItem(item);
  }

  addFeaturedLinkMetaDecorator(decorator) {
    addFeaturedLinkMetaDecorator(decorator);
  }

  /**
   * Adds items to dropdown's in search-advanced-options.
   *
   * ```
   * api.addAdvancedSearchOptions({
   *   inOptionsForUsers:[{
   *     name: I18n.t("search.advanced.in.assigned"),
   *     value: "assigned",
   *   },
   *   {
   *     name: I18n.t("search.advanced.in.not_assigned"),
   *     value: "not_assigned",
   *   },]
   *   statusOptions: [{
   *     name: I18n.t("search.advanced.status.open"),
   *     value: "open"
   *   }]
   * ```
   *
   **/
  addAdvancedSearchOptions(options) {
    addAdvancedSearchOptions(options);
  }

  /**
   * Registers a user field that can be saved via the user preferences API.
   * User fields are admin-defined profile fields stored in the user_fields table.
   *
   * @param {string} fieldName - The name of the user field to save
   * @param {Object} [options] - Optional configuration
   * @param {string} [options.page] - The preferences page where this field should be saved.
   *   Valid pages: "account", "emails", "interface", "navigation-menu", "notifications",
   *   "profile", "tags", "tracking", "users"
   *
   * @example
   * // Register a user field that will be saved on the emails preferences page
   * api.addSaveableUserField("newsletter_subscribe", { page: "emails" });
   */
  addSaveableUserField(fieldName, options = {}) {
    addSaveableUserField(fieldName);

    if (options.page) {
      this.registerValueTransformer(
        "preferences-save-attributes",
        ({ value: attrs, context }) => {
          if (context.page === options.page) {
            attrs.push(fieldName);
          }
          return attrs;
        }
      );
    }
  }

  /**
   * Registers a user option that can be saved via the user preferences API.
   * User options are preference settings stored in the user_options table.
   *
   * @param {string} fieldName - The name of the user option to save
   * @param {Object} [options] - Optional configuration
   * @param {string} [options.page] - The preferences page where this option should be saved.
   *   Valid pages: "account", "emails", "interface", "navigation-menu", "notifications",
   *   "profile", "tags", "tracking", "users"
   *
   * @example
   * // Register a user option that will be saved on the emails preferences page
   * api.addSaveableUserOption("chat_email_frequency", { page: "emails" });
   *
   * @example
   * // Register a user option without specifying a page (for use with custom preference pages)
   * api.addSaveableUserOption("my_custom_setting");
   */
  addSaveableUserOption(fieldName, options = {}) {
    addSaveableUserOptionField(fieldName);

    if (options.page) {
      this.registerValueTransformer(
        "preferences-save-attributes",
        ({ value: attrs, context }) => {
          if (context.page === options.page) {
            attrs.push(fieldName);
          }
          return attrs;
        }
      );
    }
  }

  /**
   * @deprecated Use `addSaveableUserOption` instead
   */
  addSaveableUserOptionField(fieldName, options = {}) {
    deprecated(
      "`addSaveableUserOptionField` has been renamed to `addSaveableUserOption`",
      {
        id: "discourse.add-saveable-user-option-field",
        since: "2026.3",
      }
    );

    this.addSaveableUserOption(fieldName, options);
  }

  /**
   * Ensures custom_fields are saved on a specific preferences page.
   * Custom fields are stored in the user_custom_fields table.
   *
   * Unlike `addSaveableUserOption` and `addSaveableUserField` which track
   * individual field names, this method ensures the entire `custom_fields`
   * object is included in the save payload. Multiple plugins can safely
   * call this for the same page - `custom_fields` will only be added once.
   *
   * @param {string} page - The preferences page where custom_fields should be saved.
   *   Valid pages: "account", "emails", "interface", "navigation-menu", "notifications",
   *   "profile", "tags", "tracking", "users"
   *
   * @example
   * // Ensure custom_fields are saved on the notifications preferences page
   * api.addSaveableCustomFields("notifications");
   */
  addSaveableCustomFields(page) {
    if (!page) {
      const message =
        "addSaveableCustomFields requires a `page` argument to specify which preferences page should save custom_fields";
      if (isDevelopment() || isTesting()) {
        throw new Error(message);
      }
      return;
    }

    this.registerValueTransformer(
      "preferences-save-attributes",
      ({ value: attrs, context }) => {
        if (context.page === page && !attrs.includes("custom_fields")) {
          attrs.push("custom_fields");
        }
        return attrs;
      }
    );
  }

  /**
   * Adds additional params to be sent to the reviewable/:id/perform/:action
   * endpoint for a given reviewable type. This is so plugins can provide more
   * complex reviewable actions that may depend on a custom modal.
   *
   * This is copied from the reviewable model instance when performing an action
   * on the ReviewableItem component.
   *
   * ```
   * api.addPluginReviewableParam("ReviewablePluginType", "some_param");
   * ```
   **/
  addPluginReviewableParam(reviewableType, param) {
    addPluginReviewableParam(reviewableType, param);
  }

  /**
   * Registers a mapping between a JavaScript modal component class and a server-side reviewable
   * action, which is registered via `actions.add` and `build_actions`.
   *
   * For more information about modal classes, which are special Ember components used with
   * the DModal API, see:
   *
   * https://meta.discourse.org/t/using-the-dmodal-api-to-render-modal-windows-aka-popups-dialogs-in-discourse/268304.
   *
   * @param {String} reviewableAction - The action name, as registered in the server-side.
   * @param {Class} modalClass - The actual JavaScript class of the modal.
   *
   * @example
   * ```
   * api.registerReviewableActionModal("approve_category_expert", ExpertGroupChooserModal);
   * ```
   **/
  registerReviewableActionModal(reviewableType, modalClass) {
    registerReviewableActionModal(reviewableType, modalClass);
  }

  /**
   * Registers the component used to render a reviewable type in the review queue.
   *
   * The loader returns the component class, or a promise resolving to it — in
   * which case the module is only loaded when a reviewable of that type is
   * rendered.
   *
   * @param {String} reviewableType - The reviewable type class name (e.g. "ReviewableChatMessage")
   * @param {Function} loader - A function returning the component class, or a promise
   *   resolving to it
   *
   * @example
   * ```
   * api.registerReviewableComponent("ReviewableChatMessage", () => ReviewableChatMessage);
   * ```
   *
   * @example
   * ```
   * api.registerReviewableComponent(
   *   "ReviewableChatMessage",
   *   async () => (await import("../components/reviewable/chat-message")).default
   * );
   * ```
   **/
  registerReviewableComponent(reviewableType, loader) {
    if (typeof loader !== "function") {
      throw new Error(
        `registerReviewableComponent("${reviewableType}", ...) requires a function as second argument.`
      );
    }

    this.registerValueTransformer(
      "reviewable-component",
      ({ value, context }) => (context.type === reviewableType ? loader : value)
    );
  }

  /**
   * Register custom status names for a reviewable type, used in the
   * review queue status badge (e.g. "Tool approved" instead of "Flag approved").
   *
   * The names are i18n key suffixes looked up as `review.statuses.{name}.title`.
   *
   * @param {String} reviewableType - The reviewable class name (e.g. "ReviewableAiToolAction")
   * @param {String} approvedName - Status name for approved items
   * @param {String} rejectedName - Status name for rejected items
   *
   * @example
   * ```
   * api.registerReviewableStatusName("ReviewableAiToolAction", "approved_tool_action", "rejected_tool_action");
   * ```
   **/
  registerReviewableStatusName(reviewableType, approvedName, rejectedName) {
    registerReviewableStatusName(reviewableType, approvedName, rejectedName);
  }

  /**
   * Change the default category background and text colors in the
   * category creation modal.
   *
   * ```
   * api.setNewCategoryDefaultColors(
   *   'FFFFFF', // background color
   *   '000000'  // text color
   *  )
   * ```
   *
   **/
  setNewCategoryDefaultColors(backgroundColor, textColor) {
    this.registerValueTransformer("category-default-colors", () => {
      return { backgroundColor, textColor };
    });
  }

  /**
   * Change the number of notifications that are loaded at /my/notifications
   *
   * ```
   * api.setNotificationsLimit(20)
   * ```
   *
   **/
  setNotificationsLimit(limit) {
    setNotificationsLimit(limit);
  }

  /**
   * Add a callback to modify search results before displaying them.
   *
   * ```
   * api.addSearchResultsCallback((results) => {
   *   results.topics.push(Topic.create({ ... }));
   *   return results;
   * });
   * ```
   *
   */
  addSearchResultsCallback(callback) {
    addSearchResultsCallback(callback);
  }

  /**
   * Add a callback to search before logging the search record. Return false to prevent logging.
   *
   * ```
   * api.addLogSearchLinkClickedCallbacks((params) => {
   *  if (params.searchResultId === "foo") {
   *   return false;
   *  }
   * });
   * ```
   *
   */
  addLogSearchLinkClickedCallbacks(callback) {
    addLogSearchLinkClickedCallbacks(callback);
  }

  /**
   * Add a suggestion shortcut to search menu panel.
   *
   * ```
   * api.addSearchSuggestion("in:assigned");
   * ```
   *
   */
  addSearchSuggestion(value) {
    addSearchSuggestion(value);
  }

  /**
   * Add a callback that will be evaluated when search menu assistant-items are clicked. Function
   * takes an object as it's only argument. This object includes the updated term, searchTermChanged function,
   * and the usage. If any callbacks return false, the core logic will be halted
   *
   * ```
   * api.addSearchMenuAssistantSelectCallback((args) => {
   *   if (args.usage !== "recent-search") {
   *     return true;
   *   }
   *   args.searchTermChanged(args.updatedTerm)
   *   return false;
   * })
   * ```
   *
   */
  addSearchMenuAssistantSelectCallback(fn) {
    addSearchMenuAssistantSelectCallback(fn);
  }

  /**
   * Force a given menu panel (search-menu, user-menu) to be displayed as dropdown if ANY of the passed `classNames` are included in the `classList` of a menu panel.
   * This can be useful for plugins as the default behavior is to add a 'slide-in' behavior to a menu panel if you are viewing on a small screen. eg. mobile.
   * Sometimes when we are rendering the menu panel in a non-standard way we don't want this behavior and want to force the menu panel to be displayed as a dropdown.
   *
   * The `classNames` param can be passed as a single string or an array of strings. This way you can disable the 'slide-in' behavior for multiple menu panels.
   *
   * ```
   * api.forceDropdownForMenuPanels(["search-menu-panel", "user-menu"]);
   * ```
   *
   */
  forceDropdownForMenuPanels(classNames) {
    glimmerForceDropdownForMenuPanels(classNames);
  }

  /**
   * Add an event to an ICS-compatible app, Google Calendar, Microsoft Outlook, or Apple Calendar. Optionally, recurrence rule can be specified - https://datatracker.ietf.org/doc/html/rfc5545#section-3.3.10
   *
   * ```javascript
   * api.downloadCalendar("title of the event",
   *   [
   *     {
   *       startsAt: "2021-10-12T15:00:00.000Z",
   *       endsAt: "2021-10-12T16:00:00.000Z",
   *     },
   *   ],
   *   { rrule: "FREQ=DAILY;BYDAY=MO,TU,WE,TH,FR", location: "Paris", details: "Foo" }
   * );
   * ```
   */
  downloadCalendar(title, dates, options = {}) {
    downloadCalendar(title, dates, options);
  }

  /**
   * Add a function to be called when there is a keyDown even on the search-menu.
   * This function runs before the default logic, and if one callback returns a falsey value
   * the logic chain will stop, to prevent the core behavior from occurring.
   *
   * Example usage:
   * ```
   * api.addSearchMenuOnKeyDownCallback((searchMenu, event) => {
   *  if (searchMenu.term === "stop") {
   *    return false;
   *  }
   * });
   * ```
   *
   */
  addSearchMenuOnKeyDownCallback(fn) {
    addOnKeyUpCallback(fn);
  }

  /**
   * Add a quick search tip shown randomly when the search dropdown is invoked on desktop.
   *
   * Example usage:
   * ```
   * const tip = {
   *    label: "in:docs",
   *    description: I18n.t("search.tips.in_docs"),
   *    clickable: true,
   *    showTopics: true
   * };
   * api.addQuickSearchRandomTip(tip);
   * ```
   *
   */
  addQuickSearchRandomTip(tip) {
    addQuickSearchRandomTip(tip);
  }

  /**
   * Remove the default quick search tips shown randomly when the search dropdown is invoked on desktop.
   *
   * Usage:
   * ```
   * api.removeDefaultQuickSearchRandomTips();
   * ```
   *
   */
  removeDefaultQuickSearchRandomTips() {
    removeDefaultQuickSearchRandomTips();
  }

  /**
   * Add custom user search options.
   * It is heavily correlated with `register_groups_callback_for_users_search_controller_action` which allows defining custom filter.
   * Example usage:
   *
   * ```
   * api.addUserSearchOption("adminsOnly");
   *
   * register_groups_callback_for_users_search_controller_action(:admins_only) do |groups, user|
   *   groups.where(name: "admins")
   * end
   *
   * {{email-group-user-chooser
   *   options=(hash
   *     includeGroups=true
   *     adminsOnly=true
   *   )
   * }}
   * ```
   */
  addUserSearchOption(value) {
    CUSTOM_USER_SEARCH_OPTIONS.push(value);
  }

  /**
   * Support for customizing the composer text. By providing a callback. Callbacks should
   * return `null` or `undefined` if you don't need a customization based on the current state.
   *
   * Supported callback keys: `actionTitle`, `saveLabel`, `saveIcon`,
   * `titlePlaceholder`. Each callback receives the composer model and
   * returns an i18n key (or a translated string for `actionTitle`, or an
   * icon name for `saveIcon`). Return `null` or `undefined` to fall
   * through to the default.
   *
   * ```
   * api.customizeComposerText({
   *   actionTitle(model) {
   *     if (model.hello) {
   *        return "hello.world";
   *     }
   *   },
   *
   *   saveLabel(model) {
   *     return "my.custom_save_label_key";
   *   },
   *
   *   titlePlaceholder(model) {
   *     if (model.creatingEvent) {
   *       return "my.event_title_placeholder";
   *     }
   *   }
   * })
   *
   */
  customizeComposerText(callbacks) {
    registerCustomizationCallback(callbacks);
  }

  /**
   * Support for adding a navigation link to Sidebar Community section under the "More..." links drawer by returning a
   * class which extends from the BaseSectionLink class interface. See `lib/sidebar/user/community-section/base-section-link.js`
   * for documentation on the BaseSectionLink class interface.
   *
   * ```
   * api.addCommunitySectionLink((baseSectionLink) => {
   *   return class CustomSectionLink extends baseSectionLink {
   *     get name() {
   *       return "bookmarked";
   *     }
   *
   *     get route() {
   *       return "userActivity.bookmarks";
   *     }
   *
   *     get model() {
   *       return this.currentUser;
   *     }
   *
   *     get title() {
   *       return I18n.t("sidebar.sections.topics.links.bookmarked.title");
   *     }
   *
   *     get text() {
   *       return I18n.t("sidebar.sections.topics.links.bookmarked.content");
   *     }
   *   }
   * })
   * ```
   *
   * or
   *
   * ```
   * api.addCommunitySectionLink({
   *   name: "unread",
   *   route: "discovery.unread",
   *   title: I18n.t("some.unread.title"),
   *   text: I18n.t("some.unread.text")
   * })
   * ```
   *
   * @callback addCommunitySectionLinkCallback
   * @param {BaseSectionLink} baseSectionLink - Factory class to inherit from.
   * @returns {BaseSectionLink} - A class that extends BaseSectionLink.
   *
   * @param {(addCommunitySectionLinkCallback|Object)} arg - A callback function or an Object.
   * @param {string} arg.name - The name of the link. Needs to be dasherized and lowercase.
   * @param {string} arg.title - The title attribute for the link.
   * @param {string} arg.text - The text to display for the link.
   * @param {string} [arg.route] - The Ember route name to generate the href attribute for the link.
   * @param {string} [arg.href] - The href attribute for the link.
   * @param {string} [arg.icon] - The FontAwesome icon to display for the link.
   * @param {Boolean} [secondary] - Determines whether the section link should be added to the main or secondary section in the "More..." links drawer.
   */
  addCommunitySectionLink(arg, secondary) {
    addCustomCommunitySectionLink(arg, secondary);
  }

  /**
   * Registers a new countable for section links under Sidebar Categories section on top of the default countables of
   * unread topics count and new topics count.
   *
   * ```
   * api.registerUserCategorySectionLinkCountable({
   *   badgeTextFunction: (count) => {
   *     return I18n.t("custom.open_count", count: count");
   *   },
   *   route: "discovery.openCategory",
   *   shouldRegister: ({ category } => {
   *     return category.custom_fields.enable_open_topics_count;
   *   }),
   *   refreshCountFunction: ({ _topicTrackingState, category } => {
   *     return category.open_topics_count;
   *   }),
   *   prioritizeDefaults: ({ currentUser, category } => {
   *     return category.custom_fields.show_open_topics_count_first;
   *   })
   * })
   * ```
   *
   * @callback badgeTextFunction
   * @param {Integer} count - The count as given by the `refreshCountFunction`.
   * @returns {String} - Text for the badge displayed in the section link.
   *
   * @callback shouldRegister
   * @param {Object} arg
   * @param {Category} arg.category - The category model for the sidebar section link.
   * @returns {Boolean} - Whether the countable should be registered for the sidebar section link.
   *
   * @callback refreshCountFunction
   * @param {Object} arg
   * @param {Category} arg.category - The category model for the sidebar section link.
   * @returns {integer} - The value used to set the property for the count.
   *
   * @callback prioritizeOverDefaults
   * @param {Object} arg
   * @param {Category} arg.category - The category model for the sidebar section link.
   * @param {User} arg.currentUser - The user model for the current user.
   * @returns {boolean} - Whether the countable should be prioritized over the defaults.
   *
   * @param {Object} arg - An object
   * @param {string} arg.badgeTextFunction - Function used to generate the text for the badge displayed in the section link.
   * @param {string} arg.route - The Ember route name to generate the href attribute for the link.
   * @param {Object} [arg.routeQuery] - Object representing the query params that should be appended to the route generated.
   * @param {shouldRegister} arg.shouldRegister - Function used to determine if the countable should be registered for the category.
   * @param {refreshCountFunction} arg.refreshCountFunction - Function used to calculate the value used to set the property for the count whenever the sidebar section link refreshes.
   * @param {prioritizeOverDefaults} args.prioritizeOverDefaults - Function used to determine whether the countable should be prioritized over the default countables of unread/new.
   */
  registerUserCategorySectionLinkCountable({
    badgeTextFunction,
    route,
    routeQuery,
    shouldRegister,
    refreshCountFunction,
    prioritizeOverDefaults,
  }) {
    registerUserCategorySectionLinkCountable({
      badgeTextFunction,
      route,
      routeQuery,
      shouldRegister,
      refreshCountFunction,
      prioritizeOverDefaults,
    });
  }

  /**
   * Changes the lock icon used for a sidebar category section link to indicate that a category is read restricted.
   *
   * @param {String} Name of a FontAwesome icon
   */
  registerCustomCategorySectionLinkLockIcon(icon) {
    return registerCustomCategoryLockIcon(icon);
  }

  /**
   * Register a custom prefix for a sidebar category section link.
   *
   * Example:
   *
   * ```
   * api.registerCustomCategorySectionLinkPrefix({
   *   categoryId: category.id,
   *   prefixType: "icon",
   *   prefixValue: "wrench",
   *   prefixColor: "FF0000"
   * })
   * ```
   *
   * @param {Object} arg - An object
   * @param {string} arg.categoryId - The id of the category
   * @param {string} arg.prefixType - The type of prefix to use. Can be "icon", "image", "text" or "span".
   * @param {string} arg.prefixValue - The value of the prefix to use.
   *                                    For "icon", pass in the name of a FontAwesome icon.
   *                                    For "image", pass in the src of the image.
   *                                    For "text", pass in the text to display.
   *                                    For "span", pass in an array containing two hex color values. Example: `[FF0000, 000000]`.
   * @param {string} arg.prefixColor - The color of the prefix to use. Example: "FF0000".
   */
  registerCustomCategorySectionLinkPrefix({
    categoryId,
    prefixType,
    prefixValue,
    prefixColor,
  }) {
    registerCustomCategorySectionLinkPrefix({
      categoryId,
      prefixType,
      prefixValue,
      prefixColor,
    });
  }

  /**
   * Register a custom prefix for a sidebar tag section link.
   *
   * Example:
   *
   * ```
   * api.registerCustomTagSectionLinkPrefixValue({
   *   tagName: "tag1",
   *   prefixType: "icon",
   *   prefixValue: "wrench",
   *   prefixColor: "#FF0000"
   * });
   * ```
   *
   * @param {Object} arg - An object
   * @param {string} arg.tagName - The name of the tag
   * @param {string} arg.prefixValue - The name of a FontAwesome icon.
   * @param {string} arg.prefixColor - The color represented using hexadecimal to use for the prefix. Example: "#FF0000" or "#FFF".
   */
  registerCustomTagSectionLinkPrefixIcon({
    tagName,
    prefixValue,
    prefixColor,
  }) {
    registerCustomTagSectionLinkPrefixIcon({
      tagName,
      prefixValue,
      prefixColor,
    });
  }

  /**
   * Triggers a refresh of the counts for all category section links under the categories section for a logged in user.
   */
  refreshUserSidebarCategoriesSectionCounts() {
    const appEvents = this._lookupContainer("service:app-events");

    appEvents?.trigger(
      REFRESH_USER_SIDEBAR_CATEGORIES_SECTION_COUNTS_APP_EVENT_NAME
    );
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Support for adding a Sidebar panel by returning a class which extends from the BaseCustomSidebarPanel
   * class interface. See `lib/sidebar/user/base-custom-sidebar-panel.js` for documentation on the BaseCustomSidebarPanel class
   * interface.
   *
   * ```
   * api.addSidebarPanel((BaseCustomSidebarPanel) => {
   *   const ChatSidebarPanel = class extends BaseCustomSidebarPanel {
   *     get key() {
   *       return "chat";
   *     }
   *     get switchButtonLabel() {
   *       return I18n.t("sidebar.panels.chat.label");
   *     }
   *     get switchButtonIcon() {
   *       return "d-chat";
   *     }
   *     get switchButtonDefaultUrl() {
   *       return "/chat";
   *     }
   *   };
   *   return ChatSidebarPanel;
   * });
   * ```
   */
  addSidebarPanel(func) {
    addSidebarPanel(func);
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Support for adding links to specific admin sidebar sections.
   *
   * This is intended to replace the admin-menu plugin outlet from
   * the old admin horizontal nav.
   *
   * ```javascript
   * api.addAdminSidebarSectionLink("root", {
   *   name: "unique_link_name",
   *   label: "admin.some.i18n.label.key",
   *   route: "(optional) emberRouteId",
   *   href: "(optional) can be used instead of the route",
   * }
   * ```
   *
   * @param {String} sectionName - The name of the admin sidebar section to add the link to.
   * @param {Object} link - A link object representing a section link for the sidebar.
   * @param {string} link.name - The name of the link. Needs to be dasherized and lowercase.
   * @param {string} link.title - The title attribute for the link.
   * @param {string} link.text - The text to display for the link.
   * @param {string} [link.route] - The Ember route name to generate the href attribute for the link.
   * @param {string} [link.href] - The href attribute for the link.
   * @param {string} [link.icon] - The FontAwesome icon to display for the link.
   */
  addAdminSidebarSectionLink(sectionName, link) {
    addAdminSidebarSectionLink(sectionName, link);
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Adds a link to a section of the user nav sidebar panel.
   *
   * The panel replaces the horizontal user navs, and the outlets a plugin adds
   * its tabs through (`user-main-nav`, `user-activity-bottom`,
   * `user-notifications-bottom`, `user-preferences-nav`) render markup the
   * panel cannot read. A plugin with a tab in any of them registers it here as
   * well to stay reachable once those navs are hidden.
   *
   * ```javascript
   * api.addUserNavSidebarLink("activity", {
   *   name: "activity-solved",
   *   route: "userActivity.solved",
   *   label: "solved.title",
   *   icon: "square-check",
   *   displayed: ({ siteSettings }) => siteSettings.solved_enabled,
   * });
   * ```
   *
   * @param {String} sectionName - The panel section to add the link to: profile,
   *   activity, notifications, messages, invites or preferences.
   * @param {Object} link - A link object representing a section link.
   * @param {string} link.name - The name of the link. Needs to be dasherized and lowercase.
   * @param {string} link.route - The Ember route name the link points at.
   * @param {string} link.label - The i18n key for the link's text.
   * @param {string} [link.icon] - The FontAwesome icon to display for the link.
   * @param {Array} [link.routeParams] - Extra route models, after the username.
   * @param {Function} [link.displayed] - Predicate deciding whether to show the link.
   */
  addUserNavSidebarLink(sectionName, link) {
    addUserNavSidebarLink(sectionName, link);
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Support for setting a Sidebar panel.
   */
  setSidebarPanel(name) {
    this._lookupContainer("service:sidebar-state")?.setPanel(name);
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Support for getting the current Sidebar panel.
   */
  getSidebarPanel() {
    return this._lookupContainer("service:sidebar-state")?.currentPanel;
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Set combined sidebar section mode. In this mode, sections from all panels are displayed together.
   */
  setCombinedSidebarMode() {
    this._lookupContainer("service:sidebar-state")?.setCombinedMode();
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Set separated sidebar section mode. In this mode, only sections from the current panel are displayed.
   */
  setSeparatedSidebarMode() {
    this._lookupContainer("service:sidebar-state").setSeparatedMode();
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Show sidebar switch panels buttons in separated mode.
   */
  showSidebarSwitchPanelButtons() {
    this._lookupContainer("service:sidebar-state").showSwitchPanelButtons();
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Hide sidebar switch panels buttons in separated mode.
   */
  hideSidebarSwitchPanelButtons() {
    this._lookupContainer("service:sidebar-state")?.hideSwitchPanelButtons();
  }

  /**
   * Support for adding a Sidebar section by returning a class which extends from the BaseCustomSidebarSection
   * class interface. See `lib/sidebar/user/base-custom-sidebar-section.js` for documentation on the BaseCustomSidebarSection class
   * interface.
   *
   * ```
   * api.addSidebarSection((BaseCustomSidebarSection, BaseCustomSidebarSectionLink) => {
   *   return class extends BaseCustomSidebarSection {
   *     get name() {
   *       return "chat-channels";
   *     }
   *
   *     get route() {
   *       return "chat";
   *     }
   *
   *     get title() {
   *       return I18n.t("sidebar.sections.chat.title");
   *     }
   *
   *     get text() {
   *       return I18n.t("sidebar.sections.chat.text");
   *     }
   *
   *     get actionsIcon() {
   *       return "gear";
   *     }
   *
   *     get actions() {
   *       return [
   *         { id: "browseChannels", title: "Browse channel", action: () => {} },
   *         { id: "settings", title: "Settings", action: () => {} },
   *       ];
   *     }
   *
   *     get links() {
   *       return [
   *         new (class extends BaseCustomSidebarSectionLink {
   *           get name() {
   *             "dev"
   *           }
   *           get route() {
   *             return "chat.channel";
   *           }
   *           get model() {
   *             return {
   *               channelId: "1",
   *               channelTitle: "dev channel"
   *             };
   *           }
   *           get title() {
   *             return "dev channel";
   *           }
   *           get text() {
   *             return "dev channel";
   *           }
   *           get prefixType() {
   *             return "icon";
   *           }
   *           get prefixValue() {
   *             return "hashtag";
   *           }
   *           get prefixColor() {
   *             return "000000";
   *           }
   *           get prefixBadge() {
   *             return "lock";
   *           }
   *           get suffixType() {
   *             return "icon";
   *           }
   *           get suffixValue() {
   *             return "circle";
   *           }
   *           get suffixCSSClass() {
   *             return "unread";
   *           }
   *         })(),
   *         new (class extends BaseCustomSidebarSectionLink {
   *           get name() {
   *             "random"
   *           }
   *           get route() {
   *             return "chat.channel";
   *           }
   *           get model() {
   *             return {
   *               channelId: "2",
   *               channelTitle: "random channel"
   *             };
   *           }
   *           get currentWhen() {
   *             return true;
   *           }
   *           get title() {
   *             return "random channel";
   *           }
   *           get text() {
   *             return "random channel";
   *           }
   *           get hoverType() {
   *             return "icon";
   *           }
   *           get hoverValue() {
   *             return "xmark";
   *           }
   *           get hoverAction() {
   *             return () => {};
   *           }
   *           get hoverTitle() {
   *             return "button title attribute"
   *           }
   *         })()
   *       ];
   *     }
   *   }
   * })
   * ```
   */
  addSidebarSection(func, panelKey = "main") {
    addSidebarSection(func, panelKey);
  }

  /**
   * Register a custom renderer for a notification type or override the
   * renderer of an existing type. See lib/notification-types/base.js for
   * documentation and the default renderer.
   *
   * ```
   * api.registerNotificationTypeRenderer("your_notification_type", (NotificationTypeBase) => {
   *   return class extends NotificationTypeBase {
   *     get label() {
   *       return "some label";
   *     }
   *
   *     get description() {
   *       return "fancy description";
   *     }
   *   };
   * });
   * ```
   * @callback renderDirectorRegistererCallback
   * @param {NotificationTypeBase} The base class from which the returned class should inherit.
   * @returns {NotificationTypeBase} A class that inherits from NotificationTypeBase.
   *
   * @param {string} notificationType - ID of the notification type (i.e. the key value of your notification type in the `Notification.types` enum on the server side).
   * @param {renderDirectorRegistererCallback} func - Callback function that returns a subclass from the class it receives as its argument.
   */
  registerNotificationTypeRenderer(notificationType, func) {
    registerNotificationTypeRenderer(notificationType, func);
  }

  /**
   * Registers a component used to render a report on the customisable
   * Reports section of the new admin dashboard. Pair with the server-side
   * `register_admin_dashboard_report_source` registration: the source name
   * passed here matches the provider's `source_name`. The component
   * receives `@item`, `@payload`, and `@filters` and is mounted inside the
   * card's chart area; the card frame (title, label pill, X-to-remove) is
   * owned by core.
   *
   * ```
   * import MyReportCard from "discourse/plugins/my-plugin/discourse/components/my-report-card";
   *
   * api.registerAdminDashboardReportRenderer("my_source", MyReportCard);
   * ```
   *
   * @param {string} source - The provider's source_name.
   * @param {Component} componentClass - A Glimmer component that accepts @item, @payload, @filters.
   */
  registerAdminDashboardReportRenderer(source, componentClass) {
    registerAdminDashboardReportRenderer(source, componentClass);
  }

  /**
   * Registers a component to render a whole section in the redesigned admin
   * dashboard (gated by the `dashboard_improvements` upcoming change). Pair it
   * with the server-side `register_admin_dashboard_section`: the `id` here must
   * match the one registered there, and the loader block registered there
   * produces the `@data` this component receives.
   *
   * The component is rendered once for each visible section with a matching id.
   * The render site also stamps a `--<id>` class and a `data-section-id="<id>"`
   * attribute on it, so forward `...attributes` onto your root element (wrapping
   * the shared `<DashboardSection>` component does this for you).
   *
   * The component receives these args:
   * - `@data` {Object} — the section payload: the hash returned by the
   *   server-side loader block passed to `register_admin_dashboard_section`.
   * - `@startDate` {Date} — start of the selected dashboard period.
   * - `@endDate` {Date} — end of the selected dashboard period.
   * - `@fetchError` {boolean} — true when the dashboard sections request failed.
   * - `@period` {string} — the selected period preset (e.g. "monthly"), or
   *   "custom" for a custom range.
   * - `@loading` {boolean} — true while the dashboard is (re)loading sections.
   *   Provided for convenience; a section that refetches on its own (as Solved's
   *   "support" section does) may track its own loading state instead.
   *
   * ```
   * import MySection from "discourse/plugins/my-plugin/admin/components/dashboard/my-section";
   *
   * api.registerAdminDashboardSection("my_section", MySection);
   * ```
   *
   * @param {string} id - The section id, matching the server-side registration.
   * @param {Component} componentClass - A Glimmer component for the section.
   */
  registerAdminDashboardSection(id, componentClass) {
    registerAdminDashboardSection(id, componentClass);
  }

  /**
   * Registers a new tab in the user menu. This API method expects a callback
   * that should return a class inheriting from the class (UserMenuTab) that's
   * passed to the callback. See discourse/app/lib/user-menu/tab.js for
   * documentation of UserMenuTab.
   *
   * ```
   * api.registerUserMenuTab((UserMenuTab) => {
   *   return class extends UserMenuTab {
   *     id = "custom-tab-id";
   *     panelComponent = MyCustomPanelGlimmerComponent;
   *     icon = "some-fa-icon";
   *
   *     get shouldDisplay() {
   *       return this.siteSettings.enable_custom_tab && this.currentUser.admin;
   *     }
   *
   *     get count() {
   *       return this.currentUser.my_custom_notification_count;
   *     }
   *   }
   * });
   * ```
   *
   * @callback customTabRegistererCallback
   * @param {UserMenuTab} The base class from which the returned class should inherit.
   * @returns {UserMenuTab} A class that inherits from UserMenuTab.
   *
   * @param {customTabRegistererCallback} func - Callback function that returns a subclass from the class it receives as its argument.
   */
  registerUserMenuTab(func) {
    registerUserMenuTab(func);
  }

  /**
   * Apply transformation using a callback on a list of model instances of a
   * specific type. Currently, this API only works on lists rendered in the
   * user menu such as notifications, bookmarks and topics (i.e. messages), but
   * it may be extended to other lists in other parts of the app.
   *
   * You can pass an `async` callback to this API and it'll be `await`ed and
   * block rendering until the callback finishes executing.
   *
   * ```
   * api.registerModelTransformer("topic", async (topics) => {
   *   for (const topic of topics) {
   *     const decryptedTitle = await decryptTitle(topic.encrypted_title);
   *     if (decryptedTitle) {
   *       topic.fancy_title = decryptedTitle;
   *     }
   *   }
   * });
   * ```
   *
   * @callback registerModelTransformerCallback
   * @param {Object[]} A list of model instances
   *
   * @param {string} modelName - Model type on which transformation should be applied. Currently valid types are "topic", "notification" and "bookmark".
   * @param {registerModelTransformerCallback} transformer - Callback function that receives a list of model objects of the specified type and applies transformation on them.
   */
  registerModelTransformer(modelName, transformer) {
    registerModelTransformer(modelName, transformer);
  }

  /**
   * Adds a row to the dropdown used on the `userPrivateMessages` route used to navigate between the different user
   * messages pages.
   *
   * @param {string} routeName The Ember route name to transition to when the row is selected in the dropdown
   * @param {string} name The text displayed to represent the row in the dropdown
   * @param {string} [icon] The name of the icon that will be used when displaying the row in the dropdown
   */
  addUserMessagesNavigationDropdownRow(routeName, name, icon) {
    registerCustomUserNavMessagesDropdownRow(routeName, name, icon);
  }

  /**
   * EXPERIMENTAL. Do not use.
   * Adds a new search type which can be selected when visiting the full page search UI.
   *
   * @param {string} translationKey
   * @param {string} searchTypeId
   * @param {function} searchFunc - Available arguments: fullPage controller, search args, searchKey.
   * @param {Object} [options]
   * @param {string} [options.after] - Id of the search type this one should follow; appended last when omitted or unknown.
   */
  addFullPageSearchType(translationKey, searchTypeId, searchFunc, options) {
    registerFullPageSearchType(
      translationKey,
      searchTypeId,
      searchFunc,
      options
    );
  }

  /**
   * @param {function} fn - Function that will be called before the auth complete logic is run
   * in instance-initializers/auth-complete.js. If any single callback returns false, the
   * auth-complete logic will be aborted.
   */
  addBeforeAuthCompleteCallback(fn) {
    addBeforeAuthCompleteCallback(fn);
  }

  /**
   * Registers a hashtag type and its corresponding class.
   * This is used when generating CSS classes in the hashtag-css-generator.
   *
   * @param {string} type - The type of the hashtag.
   * @param {Class} typeClassInstance - The initialized class of the hashtag type, which
   *  needs the `container`.
   */
  registerHashtagType(type, typeClassInstance) {
    registerHashtagType(type, typeClassInstance);
  }

  /**
   * Adds a button to the bulk topic actions modal.
   *
   * ```
   * api.addBulkActionButton({
   *   label: "super_plugin.bulk.enhance",
   *   icon: wand-magic,
   *   class: "btn-default",
   *   visible: ({ currentUser, siteSettings }) => siteSettings.super_plugin_enabled && currentUser.staff,
   *   async action({ setComponent }) {
   *     await doSomething(this.model.topics);
   *     setComponent(MyBulkModal);
   *   },
   * });
   * ```
   *
   * @callback buttonVisibilityCallback
   * @param {Object} opts
   * @param {Topic[]} opts.topics - the selected topic for the bulk action
   * @param {Category} opts.category - the category in which the action is performed (if applicable)
   * @param {User} opts.currentUser
   * @param {SiteSettings} opts.siteSettings
   * @returns {Boolean} - whether the button should be visible or not
   *
   * @callback buttonAction
   * @param {Object} opts
   * @param {Topic[]} opts.topics - the selected topic for the bulk action
   * @param {Category} opts.category - the category in which the action is performed (if applicable)
   * @param {function} opts.setComponent - render a template in the bulk action modal (pass in an imported component)
   * @param {function} opts.performAndRefresh
   * @param {function} opts.forEachPerformed
   *
   * @param {Object} opts
   * @param {string} opts.label
   * @param {string} opts.icon
   * @param {string} opts.class
   * @param {buttonVisibilityCallback} opts.visible
   * @param {buttonAction} opts.action
   * @param {string} opts.actionType - type of the action, either performAndRefresh or setComponent
   */
  addBulkActionButton(opts) {
    addBulkDropdownButton(opts);
  }

  /**
   * Include the passed user field property in the Admin User Field save request.
   * This is useful for plugins that are adding additional columns to the user field model and want
   * to save the new property values alongside the default user field properties (all under the same save call)
   *
   *
   * ```
   * api.includeUserFieldPropertyOnSave("property_one");
   * api.includeUserFieldPropertyOnSave("property_two");
   * ```
   *
   */
  includeUserFieldPropertyOnSave(userFieldProperty) {
    this.container
      .lookup("service:admin-custom-user-fields")
      .addProperty(userFieldProperty);
  }

  /**
   * Adds a custom button to the composer preview's image wrapper
   *
   * @param {string} label - The button label text
   * @param {string} btnClass - The CSS class for the button
   * @param {string} icon - The icon name (optional)
   * @param {Function} fn - The click handler function
   * @param {Function} includeCondition - Optional function that receives the image src and returns true if the button should be shown (optional)
   *
   * ```
   * api.addComposerImageWrapperButton(
   *   "My Custom Button",
   *   "custom-button-class",
   *   "lock",
   *   (event) => { console.log("Custom button clicked", event); },
   *   (imageSrc) => imageSrc.endsWith('.jpg') // Only show for JPG images
   * );
   * ```
   *
   */
  addComposerImageWrapperButton(label, btnClass, icon, fn, includeCondition) {
    addImageWrapperButton(label, btnClass, icon, includeCondition);
    addApiImageWrapperButtonClickEvent(fn);
  }

  /**
   * Defines a list of links used in the adminPlugins.show page for
   * a specific plugin. Each link must have:
   *
   * * route
   * * label OR text
   */
  addAdminPluginConfigurationNav(pluginId, links) {
    if (!pluginId) {
      // eslint-disable-next-line no-console
      console.warn(consolePrefix(), "A pluginId must be provided!");
      return;
    }

    registerAdminPluginConfigNav(pluginId, links);
  }

  /**
   * Sets the icon for a plugin in the admin sidebar.
   *
   * @param {string} pluginId - The plugin identifier (must match the plugin name)
   * @param {string} icon - The icon name (FontAwesome icon without 'd-icon-' prefix)
   *
   * Example:
   *
   * ```javascript
   * api.setAdminPluginIcon("discourse-calendar", "calendar-days");
   * ```
   */
  setAdminPluginIcon(pluginId, icon) {
    if (!pluginId) {
      // eslint-disable-next-line no-console
      console.warn(consolePrefix(), "A pluginId must be provided!");
      return;
    }

    if (!icon) {
      // eslint-disable-next-line no-console
      console.warn(consolePrefix(), "An icon must be provided!");
      return;
    }

    this.registerValueTransformer("admin-plugin-icon", ({ value, context }) => {
      return context.pluginId === pluginId ? icon : value;
    });
  }

  /**
   * Adds a custom site activity item in the new /about page. Requires using
   * the `register_stat` server-side API to serialize the needed data to the
   * frontend.
   *
   * ```
   * api.addAboutPageActivity("released_songs", (periods) => {
   *   return {
   *     icon: "guitar",
   *     class: "released-songs",
   *     activityText: `${periods["last_year"]} released songs`,
   *     period: "in the last year",
   *   };
   * });
   * ```
   *
   * The above example would require the `register_stat` server-side API to be
   * used like this:
   *
   * ```ruby
   * register_stat("released_songs", expose_via_api: true) do
   *   {
   *     last_year: Songs.where("released_at > ?", 1.year.ago).count,
   *     last_month: Songs.where("released_at > ?", 1.month.ago).count,
   *   }
   * end
   * ```
   *
   * @callback activityItemConfig
   * @param {Object} periods - an object containing the periods that the block given to the `register_stat` server-side API returns.
   * @returns {Object} - configuration object for the site activity item. The object must contain the following properties: `icon`, `class`, `activityText` and `period`.
   *
   * @param {string} name - a string that matches the string given to the `register_stat` server-side API.
   * @param {activityItemConfig} func - a callback that returns an object containing properties for the custom site activity item.
   */
  addAboutPageActivity(name, func) {
    addAboutPageActivity(name, func);
  }

  /**
   * Registers a component class that will be rendered within the DPageHeader component
   * only on plugins using the AdminPluginConfigPage and the new plugin "show" route.
   *
   * This component will be passed an `@actions` argument, with Primary, Default, Danger,
   * and Wrapped keys, which can be used for various different types of buttons (Wrapped
   * should be used only in very rare scenarios).
   *
   * This component would be used for actions that should be present on the entire UI
   * for that plugin -- one example is "Create export" for chat.
   *
   * @param {string} pluginId - The `dasherizedName` of the plugin using this component.
   * @param {Class} componentClass - The JS class of the component to render.
   */
  registerPluginHeaderActionComponent(pluginId, componentClass) {
    registerPluginHeaderActionComponent(pluginId, componentClass);
  }

  /**
   * Registers a new tab to be displayed in "more topics" area at the bottom of a topic page.
   *
   * ```gjs
   *  api.registerMoreTopicsTab({
   *    id: "other-topics",
   *    name: i18n("other_topics.tab"),
   *    component: <template>tbd</template>,
   *    condition: ({ topic }) => topic.otherTopics?.length > 0,
   *  });
   * ```
   *
   * You can additionally use more-topics-tabs value transformer to conditionally show/hide
   * specific tabs.
   *
   * ```js
   * api.registerValueTransformer("more-topics-tabs", ({ value, context }) => {
   *   if (context.user?.aFeatureFlag) {
   *     // Remove "suggested" from the topics page
   *     return value.filter(
   *       (tab) =>
   *         context.currentContext !== "topic" ||
   *         tab.id !== "suggested-topics"
   *     );
   *   }
   * });
   * ```
   *
   * @callback tabCondition
   * @param {Object} opts
   * @param {"topic"|"pm"} opts.context - the type of the current page
   * @param {Topic} opts.topic - the current topic
   *
   * @param {Object} tab
   * @param {string} tab.id - an identifier used in more-topics-tabs value transformer
   * @param {string} tab.name - a name displayed on the tab
   * @param {string} tab.icon - an optional icon displayed on the tab
   * @param {Class} tab.component - contents of the tab
   * @param {tabCondition} tab.condition - an optional callback to conditionally show the tab
   */
  registerMoreTopicsTab(tab) {
    registeredTabs.push(tab);
  }

  /**
   * Registers a report mode and an associated component, which will be rendered
   * by the AdminReport component. A mode is a different way of displaying the
   * report data, core modes are things like "table" and "chart". For all core modes
   * see Admin::Report::MODES.
   *
   * @param {String} mode - The identifier of the mode to register
   * @param {Class} componentClass - The class of the component to render
   */
  registerReportModeComponent(mode, componentClass) {
    registerReportModeComponent(mode, componentClass);
  }

  /**
   * Registers components that render related items for an admin report.
   *
   * @param {String} reportType - The report's identifier
   * @param {Object} renderer - The related-item renderer configuration
   * @param {Class} [renderer.relatedItemsComponent] - Component for the report detail view
   * @param {Object} [renderer.tableSummary] - Configuration for table cell summaries
   * @param {Class} renderer.tableSummary.itemComponent - Component for each summary item
   * @param {String} renderer.tableSummary.itemsKey - Related-items response key
   * @param {String} [renderer.tableSummary.listClass] - Class for the summary list
   * @param {String} renderer.tableSummary.titleKey - Summary title translation key
   */
  registerAdminReportRelatedItemsRenderer(reportType, renderer) {
    registerAdminReportRelatedItemsRenderer(reportType, renderer);
  }

  /**
   * Registers an extension for the rich editor
   *
   * EXPERIMENTAL: This API will change without warning
   *
   * @param {RichEditorExtension} extension
   */
  registerRichEditorExtension(extension) {
    registerRichEditorExtension(extension);
  }

  /**
   * Registers a property that will be included when saving a category.
   *
   * This is useful for plugins that are adding additional parameters to the category
   * and want to save the new property alongside the default category properties
   * (all under the same save call), and are not using custom fields for that.
   *
   * ```
   * api.registerCategorySaveProperty("property_one");
   * api.registerCategorySaveProperty("property_two");
   * ```
   *
   * @param {string} property - The name of the property to include when saving a category.
   */
  registerCategorySaveProperty(property) {
    _addCategoryPropertyForSave(property);
  }

  /**
   * Registers a custom tab for the category edit page.
   *
   * ```
   * api.registerEditCategoryTab({
   *   id: "chat",
   *   name: "Chat",
   *   component: MyChatComponent,
   *   condition: ({ category, siteSettings }) => siteSettings.chat_enabled,
   * });
   * ```
   *
   * @param {Object} tab
   * @param {string} tab.id - unique identifier for the tab, used in URL routing
   * @param {string} tab.name - display name shown on the tab
   * @param {Class} tab.component - Glimmer component to render as tab content
   * @param {Function} [tab.condition] - optional callback returning boolean to conditionally show the tab
   * @param {boolean} [tab.primary] - if true, tab is shown without requiring "Advanced settings" toggle
   */
  registerEditCategoryTab(tab) {
    registeredEditCategoryTabs.push(tab);
  }

  /**
   * Register a callback that runs when the user changes category type selection in the
   * category editor's General tab.
   *
   * Callbacks run in order. Each may be `async`. The change applies only if every callback
   * returns a **truthy** value; a **falsy** return blocks the new selection. If a callback
   * throws, the error is reported and the change is blocked; in tests the error is rethrown.
   *
   * The callback receives:
   * - `nextTypes` - normalized type objects after the empty-to-discussion rule
   * - `previousTypes` - selection before this change
   * - `category`, `form`, and optionally `transientData`
   *
   * @param {function(Object): (boolean|undefined|Promise<boolean|undefined>)} fn
   */
  registerOnBeforeCategoryTypesChange(fn) {
    registerOnBeforeCategoryTypesChange(fn);
  }

  /**
   * Registers block components to render in a designated outlet.
   *
   * **IMPORTANT:** Must be called in an initializer that runs after "freeze-block-registry".
   * All blocks must be registered via `registerBlock()` before this is called.
   *
   * Block outlets are extension points where themes and plugins can render custom
   * content layouts. Each block must be decorated with `@block` from "discourse/blocks".
   *
   * Blocks can have conditions that determine when they render. Conditions support
   * AND logic (array), OR logic (`any`), and NOT logic (`not`).
   *
   * @experimental This API is under active development and may change or be removed
   * in future releases without prior notice. Use with caution in production environments.
   *
   * @param {string} outletName - The block outlet identifier
   * @param {Array<import("discourse/blocks/types").LayoutEntry>} blocks - Array of layout entries
   *
   * @example
   * ```javascript
   * import { block } from "discourse/blocks";
   *
   * @block("my-banner")
   * class MyBanner extends Component {
   *   <template>
   *     <h1>{{@title}}</h1>
   *   </template>
   * }
   *
   * api.renderBlocks("homepage-blocks", [
   *   // Simple block without conditions
   *   {
   *     block: MyBanner,
   *     args: { title: "Welcome!" },
   *   },
   *   // Block with conditions (AND logic - all must pass)
   *   {
   *     block: MyBanner,
   *     args: { title: "Admin Banner" },
   *     conditions: [
   *       { type: "route", pages: ["DISCOVERY_PAGES"] },
   *       { type: "user", admin: true }
   *     ],
   *   },
   *   // Block with OR conditions
   *   {
   *     block: MyBanner,
   *     args: { title: "Staff Banner" },
   *     conditions: [
   *       { any: [
   *         { type: "user", admin: true },
   *         { type: "user", moderator: true }
   *       ]}
   *     ],
   *   },
   * ]);
   * ```
   */
  renderBlocks(outletName, blocks) {
    // Capture call site here, excluding this method, so the stack trace
    // points directly to the user's code that called api.renderBlocks().
    const callSiteError = captureCallSite(this.renderBlocks);
    _renderBlocks(outletName, blocks, this.container, callSiteError);
  }

  /**
   * Registers a block component for use with `renderBlocks()`.
   *
   * **IMPORTANT:** Must be called in a pre-initializer that runs before "freeze-block-registry".
   * The block registry is frozen by the "freeze-block-registry" initializer, preventing
   * late registrations.
   *
   * Supports two registration patterns:
   *
   * 1. **Direct class registration**: `registerBlock(BlockClass)`
   *    Registers using the block's own `blockName` from its `@block` decorator.
   *
   * 2. **Lazy loading with factory**: `registerBlock("name", () => import(...))`
   *    Registers a factory function for lazy loading. The block module won't be
   *    loaded until actually needed. The resolved block's `blockName` must match
   *    the registered name.
   *
   * @experimental This API is under active development and may change or be removed
   * in future releases without prior notice. Use with caution in production environments.
   *
   * @param {string | import("discourse/lib/blocks/-internals/types").BlockClass} blockOrName - Block class or name string for lazy loading.
   * @param {Function} [factory] - Factory function returning Promise<BlockClass> (required when first arg is name).
   *
   * @example Direct class registration
   * ```javascript
   * import HeroBanner from "../blocks/hero-banner";
   * api.registerBlock(HeroBanner);
   * ```
   *
   * @example Lazy loading with factory
   * ```javascript
   * api.registerBlock("sidebar-widget", () => import("../blocks/sidebar-widget"));
   * ```
   */
  registerBlock(blockOrName, factory) {
    if (typeof blockOrName === "string") {
      // Lazy loading: registerBlock("name", () => import(...))
      if (typeof factory !== "function") {
        throw new Error(
          `registerBlock("${blockOrName}", ...) requires a factory function as second argument.`
        );
      }
      _registerBlockFactory(blockOrName, factory, this.source);
    } else {
      // Direct class: registerBlock(BlockClass)
      _registerBlock(blockOrName, this.source);
    }
  }

  /**
   * Registers a custom block outlet where blocks can be rendered.
   *
   * This allows plugins and themes to define their own block outlets that can be
   * used with `renderBlocks()`. Custom outlets must follow naming conventions:
   * - Core outlets: `outlet-name` (kebab-case)
   * - Plugin outlets: `namespace:outlet-name` (e.g., `chat:message-actions`)
   * - Theme outlets: `theme:namespace:outlet-name` (e.g., `theme:my-theme:hero`)
   *
   * **IMPORTANT:** Must be called in a pre-initializer before "freeze-block-registry".
   *
   * @experimental This API is under active development and may change or be removed
   * in future releases without prior notice. Use with caution in production environments.
   *
   * @param {string} outletName - The outlet name (must follow naming conventions).
   * @param {Object} [options] - Outlet configuration options.
   * @param {string} [options.description] - Human-readable description of the outlet.
   *
   * @example
   * ```javascript
   * // In a pre-initializer
   * api.registerBlockOutlet("chat:message-actions", {
   *   description: "Actions displayed below chat messages",
   * });
   *
   * // Later, in an api-initializer
   * api.renderBlocks("chat:message-actions", [...]);
   * ```
   */
  registerBlockOutlet(outletName, options) {
    _registerOutlet(outletName, options, this.source);
  }

  /**
   * Registers a custom block condition type.
   *
   * Custom conditions must use the `@blockCondition` decorator from "discourse/blocks/conditions"
   * and extend `BlockCondition`. The class must implement the `evaluate(args)` method.
   *
   * **Note: The `evaluate()` method MUST be pure and idempotent.** It may be called
   * multiple times during a single render cycle, especially when debug logging
   * is enabled, and should not perform any side effects or state mutations.
   *
   * @experimental This API is under active development and may change or be removed
   * in future releases without prior notice. Use with caution in production environments.
   *
   * @param {typeof import("discourse/blocks/conditions").BlockCondition} ConditionClass - The condition class decorated with `@blockCondition`.
   *
   * @example
   * ```javascript
   * import { blockCondition, BlockCondition } from "discourse/blocks/conditions";
   *
   * @blockCondition({
   *   type: "feature-flag",
   *   args: {
   *     flag: { type: "string", required: true },
   *   },
   * })
   * class BlockFeatureFlagCondition extends BlockCondition {
   *   @service currentUser;
   *
   *   evaluate(args) {
   *     return this.currentUser?.feature_flags?.[args.flag] === true;
   *   }
   * }
   *
   * api.registerBlockConditionType(BlockFeatureFlagCondition);
   *
   * // Then use it in renderBlocks:
   * api.renderBlocks("homepage-blocks", [
   *   {
   *     block: MyBlock,
   *     conditions: [{ type: "feature-flag", flag: "new_feature" }]
   *   }
   * ]);
   * ```
   */
  registerBlockConditionType(ConditionClass) {
    _registerConditionType(ConditionClass, this.source);
  }

  // The module may not have been evaluated yet, and registers itself when it is.
  #deferModification(resolverName, retry) {
    deferClassModification(
      this.container.registry.normalize(resolverName),
      retry
    );
  }

  #deprecateModifyClass(resolverName, apiName) {
    if (!resolverName.startsWith("model:")) {
      return;
    }

    deprecated(
      `Using api.${apiName} on \`${resolverName}\` is deprecated. Use the \`addModelField\`, \`addModelAccessor\`/\`addModelGetter\`/\`addModelSetter\`, \`addModelMethod\`, \`addModelSaveProperty\` and \`addModelCallback\` APIs instead.`,
      {
        id: "discourse.modify-class-model",
        since: "2026.8",
      }
    );
  }

  _lookupContainer(path) {
    if (!this.container || this.container.isDestroying) {
      return;
    }

    return this.container.lookup(path);
  }

  _resolveClass(resolverName) {
    const normalized = this.container.registry.normalize(resolverName);
    if (
      this.container.cache[normalized] ||
      (normalized === "model:user" &&
        this.container.lookup("service:current-user"))
    ) {
      // eslint-disable-next-line no-console
      console.error(
        consolePrefix(),
        `Attempted to modify "${resolverName}", but it was already initialized earlier in the boot process (e.g. via a lookup()). Remove that lookup, or move the modifyClass call earlier in the boot process for changes to take effect. https://meta.discourse.org/t/262064`
      );
      return;
    }

    let klass;
    if (!blockedModifications.includes(normalized)) {
      klass = this.container.factoryFor(normalized) || lazyClassFor(normalized);
    }

    return klass;
  }

  // Resolves the `model:<name>` class; `stamp` marks it so instances can
  // resolve their model name at construction.
  _resolveModelClass(modelName, { stamp = false } = {}) {
    const klass = this._resolveClass(`model:${modelName}`);
    if (!klass) {
      return;
    }
    if (stamp) {
      stampModelClass(klass.class, modelName);
    }
    return klass.class;
  }
}

/**
 * Executes the provided callback function with the `PluginApi` object.
 *
 * @param {(api: _PluginApi, opts: object) => any} apiCodeCallback - The callback function to execute
 * @param {object} [opts] - Optional additional options to pass to the callback function.
 * @returns {any} The result of the `callback` function, if executed
 */
export function withPluginApi(apiCodeCallback, opts) {
  if (typeof arguments[0] === "string") {
    // Old path. First argument is the version string. Silently ignore.
    [, apiCodeCallback, opts] = arguments;
  }

  opts = opts || {};

  const api = new _PluginApi(
    getOwnerWithFallback(this),
    opts[_INTERNAL_SOURCE_KEY]
  );

  return apiCodeCallback(api, opts);
}
